/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.1.0 (NJsonSchema v10.4.3.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming



export enum GetActivitiesDtosOrderOptions {
    TitleAsc = 0,
    TitleDesc = 1,
    DateCreatedAsc = 2,
    DateCreatedDesc = 3,
    DateStartAsc = 4,
    DateStartDesc = 5,
}

export enum GetActivitiesDtosPeriodOptions {
    All = 0,
    Today = 1,
    Week = 2,
    Month = 3,
}

export enum GetActivitiesDtosPrivacyOptions {
    Mine = 1,
    All = 2,
}

export class ActivityRequestCommand {
    idActivityArea?: number;
    idActivityType?: number;
    idActivityStatus?: number;
    idActivityPriority?: number;
    idEntity?: number | undefined;
    datePublication?: string | undefined;
    dateStart?: string;
    dateEnd?: string | undefined;
    idOwner?: number;
    title?: string;
    description?: string;
    isFeatured?: boolean;
    isPrivate?: boolean;
    assignees?: number[] | undefined;
    appGroups?: number[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.idActivityArea = _data["idActivityArea"];
            this.idActivityType = _data["idActivityType"];
            this.idActivityStatus = _data["idActivityStatus"];
            this.idActivityPriority = _data["idActivityPriority"];
            this.idEntity = _data["idEntity"];
            this.datePublication = _data["datePublication"];
            this.dateStart = _data["dateStart"];
            this.dateEnd = _data["dateEnd"];
            this.idOwner = _data["idOwner"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.isFeatured = _data["isFeatured"];
            this.isPrivate = _data["isPrivate"];
            if (Array.isArray(_data["assignees"])) {
                this.assignees = [] as any;
                for (let item of _data["assignees"])
                    this.assignees!.push(item);
            }
            if (Array.isArray(_data["appGroups"])) {
                this.appGroups = [] as any;
                for (let item of _data["appGroups"])
                    this.appGroups!.push(item);
            }
        }
    }

    static fromJS(data: any): ActivityRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivityArea"] = this.idActivityArea;
        data["idActivityType"] = this.idActivityType;
        data["idActivityStatus"] = this.idActivityStatus;
        data["idActivityPriority"] = this.idActivityPriority;
        data["idEntity"] = this.idEntity;
        data["datePublication"] = this.datePublication;
        data["dateStart"] = this.dateStart;
        data["dateEnd"] = this.dateEnd;
        data["idOwner"] = this.idOwner;
        data["title"] = this.title;
        data["description"] = this.description;
        data["isFeatured"] = this.isFeatured;
        data["isPrivate"] = this.isPrivate;
        if (Array.isArray(this.assignees)) {
            data["assignees"] = [];
            for (let item of this.assignees)
                data["assignees"].push(item);
        }
        if (Array.isArray(this.appGroups)) {
            data["appGroups"] = [];
            for (let item of this.appGroups)
                data["appGroups"].push(item);
        }
        return data; 
    }

    clone(): ActivityRequestCommand {
        const json = this.toJSON();
        let result = new ActivityRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateActivityCommand extends ActivityRequestCommand {
    files?: string[] | undefined;
    metadata?: MetadataConfigurationFieldSimple[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(item);
            }
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(MetadataConfigurationFieldSimple.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateActivityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): CreateActivityCommand {
        const json = this.toJSON();
        let result = new CreateActivityCommand();
        result.init(json);
        return result;
    }
}

export class MetadataConfigurationFieldSimple {
    idMetadataField?: number;
    value?: string | undefined;
    options?: number[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.idMetadataField = _data["idMetadataField"];
            this.value = _data["value"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
        }
    }

    static fromJS(data: any): MetadataConfigurationFieldSimple {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataConfigurationFieldSimple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataField"] = this.idMetadataField;
        data["value"] = this.value;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        return data; 
    }

    clone(): MetadataConfigurationFieldSimple {
        const json = this.toJSON();
        let result = new MetadataConfigurationFieldSimple();
        result.init(json);
        return result;
    }
}

export class EditActivityCommand extends ActivityRequestCommand {
    idActivity?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idActivity = _data["idActivity"];
        }
    }

    static fromJS(data: any): EditActivityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditActivityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivity"] = this.idActivity;
        super.toJSON(data);
        return data; 
    }

    clone(): EditActivityCommand {
        const json = this.toJSON();
        let result = new EditActivityCommand();
        result.init(json);
        return result;
    }
}

export class CreateActivityFileCommand {
    idActivity?: number;
    title?: string;
    filename?: string;
    isPublic?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idActivity = _data["idActivity"];
            this.title = _data["title"];
            this.filename = _data["filename"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): CreateActivityFileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityFileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivity"] = this.idActivity;
        data["title"] = this.title;
        data["filename"] = this.filename;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): CreateActivityFileCommand {
        const json = this.toJSON();
        let result = new CreateActivityFileCommand();
        result.init(json);
        return result;
    }
}

export class EditActivityFileCommand {
    idActivityFile?: number;
    title?: string;
    filename?: string;
    isPublic?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idActivityFile = _data["idActivityFile"];
            this.title = _data["title"];
            this.filename = _data["filename"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): EditActivityFileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditActivityFileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivityFile"] = this.idActivityFile;
        data["title"] = this.title;
        data["filename"] = this.filename;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): EditActivityFileCommand {
        const json = this.toJSON();
        let result = new EditActivityFileCommand();
        result.init(json);
        return result;
    }
}

export class StartActivityLogtimeWorkCommand {
    idActivity?: number;

    init(_data?: any) {
        if (_data) {
            this.idActivity = _data["idActivity"];
        }
    }

    static fromJS(data: any): StartActivityLogtimeWorkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new StartActivityLogtimeWorkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivity"] = this.idActivity;
        return data; 
    }

    clone(): StartActivityLogtimeWorkCommand {
        const json = this.toJSON();
        let result = new StartActivityLogtimeWorkCommand();
        result.init(json);
        return result;
    }
}

export class PauseActivityLogtimeWorkCommand {
    idActivity?: number;

    init(_data?: any) {
        if (_data) {
            this.idActivity = _data["idActivity"];
        }
    }

    static fromJS(data: any): PauseActivityLogtimeWorkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PauseActivityLogtimeWorkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivity"] = this.idActivity;
        return data; 
    }

    clone(): PauseActivityLogtimeWorkCommand {
        const json = this.toJSON();
        let result = new PauseActivityLogtimeWorkCommand();
        result.init(json);
        return result;
    }
}

export class CompleteActivityLogtimeWorkCommand {
    idActivity?: number;
    description?: string | undefined;
    isBillable?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idActivity = _data["idActivity"];
            this.description = _data["description"];
            this.isBillable = _data["isBillable"];
        }
    }

    static fromJS(data: any): CompleteActivityLogtimeWorkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteActivityLogtimeWorkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivity"] = this.idActivity;
        data["description"] = this.description;
        data["isBillable"] = this.isBillable;
        return data; 
    }

    clone(): CompleteActivityLogtimeWorkCommand {
        const json = this.toJSON();
        let result = new CompleteActivityLogtimeWorkCommand();
        result.init(json);
        return result;
    }
}

export class CreateActivityLogtimeCommand {
    idActivity?: number;
    dateStart?: string;
    dateEnd?: string;
    description?: string | undefined;
    isBillable?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idActivity = _data["idActivity"];
            this.dateStart = _data["dateStart"];
            this.dateEnd = _data["dateEnd"];
            this.description = _data["description"];
            this.isBillable = _data["isBillable"];
        }
    }

    static fromJS(data: any): CreateActivityLogtimeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityLogtimeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivity"] = this.idActivity;
        data["dateStart"] = this.dateStart;
        data["dateEnd"] = this.dateEnd;
        data["description"] = this.description;
        data["isBillable"] = this.isBillable;
        return data; 
    }

    clone(): CreateActivityLogtimeCommand {
        const json = this.toJSON();
        let result = new CreateActivityLogtimeCommand();
        result.init(json);
        return result;
    }
}

export class EditActivityLogtimeCommand {
    idActivityLogtime?: number;
    dateStart?: string;
    dateEnd?: string;
    description?: string | undefined;
    isBillable?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idActivityLogtime = _data["idActivityLogtime"];
            this.dateStart = _data["dateStart"];
            this.dateEnd = _data["dateEnd"];
            this.description = _data["description"];
            this.isBillable = _data["isBillable"];
        }
    }

    static fromJS(data: any): EditActivityLogtimeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditActivityLogtimeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivityLogtime"] = this.idActivityLogtime;
        data["dateStart"] = this.dateStart;
        data["dateEnd"] = this.dateEnd;
        data["description"] = this.description;
        data["isBillable"] = this.isBillable;
        return data; 
    }

    clone(): EditActivityLogtimeCommand {
        const json = this.toJSON();
        let result = new EditActivityLogtimeCommand();
        result.init(json);
        return result;
    }
}

export class CreateActivityCommentCommand {
    idActivity?: number;
    message?: string;
    isPublic?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idActivity = _data["idActivity"];
            this.message = _data["message"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): CreateActivityCommentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityCommentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivity"] = this.idActivity;
        data["message"] = this.message;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): CreateActivityCommentCommand {
        const json = this.toJSON();
        let result = new CreateActivityCommentCommand();
        result.init(json);
        return result;
    }
}

export class ChangeActivityStatusCommand {
    idActivity?: number;
    idActivityStatus?: number;

    init(_data?: any) {
        if (_data) {
            this.idActivity = _data["idActivity"];
            this.idActivityStatus = _data["idActivityStatus"];
        }
    }

    static fromJS(data: any): ChangeActivityStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeActivityStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivity"] = this.idActivity;
        data["idActivityStatus"] = this.idActivityStatus;
        return data; 
    }

    clone(): ChangeActivityStatusCommand {
        const json = this.toJSON();
        let result = new ChangeActivityStatusCommand();
        result.init(json);
        return result;
    }
}

export class EditActivityMetadataCommand {
    idActivity?: number;
    metadata?: MetadataConfigurationFieldSimple[];

    init(_data?: any) {
        if (_data) {
            this.idActivity = _data["idActivity"];
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(MetadataConfigurationFieldSimple.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditActivityMetadataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditActivityMetadataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivity"] = this.idActivity;
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item.toJSON());
        }
        return data; 
    }

    clone(): EditActivityMetadataCommand {
        const json = this.toJSON();
        let result = new EditActivityMetadataCommand();
        result.init(json);
        return result;
    }
}

export class ActivityAreaRequestCommand {
    orderId?: number;
    idLanguage?: number;
    title?: string;
    isControlledByStatus?: boolean;
    allowDateEnd?: boolean;
    allowDatePublication?: boolean;
    allowFileInCreateView?: boolean;
    hasLogTime?: boolean;
    icon?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.idLanguage = _data["idLanguage"];
            this.title = _data["title"];
            this.isControlledByStatus = _data["isControlledByStatus"];
            this.allowDateEnd = _data["allowDateEnd"];
            this.allowDatePublication = _data["allowDatePublication"];
            this.allowFileInCreateView = _data["allowFileInCreateView"];
            this.hasLogTime = _data["hasLogTime"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): ActivityAreaRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityAreaRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["idLanguage"] = this.idLanguage;
        data["title"] = this.title;
        data["isControlledByStatus"] = this.isControlledByStatus;
        data["allowDateEnd"] = this.allowDateEnd;
        data["allowDatePublication"] = this.allowDatePublication;
        data["allowFileInCreateView"] = this.allowFileInCreateView;
        data["hasLogTime"] = this.hasLogTime;
        data["icon"] = this.icon;
        return data; 
    }

    clone(): ActivityAreaRequestCommand {
        const json = this.toJSON();
        let result = new ActivityAreaRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateActivityAreaCommand extends ActivityAreaRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateActivityAreaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityAreaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateActivityAreaCommand {
        const json = this.toJSON();
        let result = new CreateActivityAreaCommand();
        result.init(json);
        return result;
    }
}

export class EditActivityAreaCommand extends ActivityAreaRequestCommand {
    idActivityArea?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idActivityArea = _data["idActivityArea"];
        }
    }

    static fromJS(data: any): EditActivityAreaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditActivityAreaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivityArea"] = this.idActivityArea;
        super.toJSON(data);
        return data; 
    }

    clone(): EditActivityAreaCommand {
        const json = this.toJSON();
        let result = new EditActivityAreaCommand();
        result.init(json);
        return result;
    }
}

export class EditActivityAreaMetadataGroupsConfigurationCommand {
    idLanguage?: number;
    idActivityArea?: number;
    metadataGroups?: number[];

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idActivityArea = _data["idActivityArea"];
            if (Array.isArray(_data["metadataGroups"])) {
                this.metadataGroups = [] as any;
                for (let item of _data["metadataGroups"])
                    this.metadataGroups!.push(item);
            }
        }
    }

    static fromJS(data: any): EditActivityAreaMetadataGroupsConfigurationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditActivityAreaMetadataGroupsConfigurationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idActivityArea"] = this.idActivityArea;
        if (Array.isArray(this.metadataGroups)) {
            data["metadataGroups"] = [];
            for (let item of this.metadataGroups)
                data["metadataGroups"].push(item);
        }
        return data; 
    }

    clone(): EditActivityAreaMetadataGroupsConfigurationCommand {
        const json = this.toJSON();
        let result = new EditActivityAreaMetadataGroupsConfigurationCommand();
        result.init(json);
        return result;
    }
}

export class ReorderActivityAreaCommand {
    ids?: number[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderActivityAreaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderActivityAreaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }

    clone(): ReorderActivityAreaCommand {
        const json = this.toJSON();
        let result = new ReorderActivityAreaCommand();
        result.init(json);
        return result;
    }
}

export class ActivityPriorityRequestCommand {
    orderId?: number;
    idLanguage?: number;
    title?: string;
    color?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.idLanguage = _data["idLanguage"];
            this.title = _data["title"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ActivityPriorityRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityPriorityRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["idLanguage"] = this.idLanguage;
        data["title"] = this.title;
        data["color"] = this.color;
        return data; 
    }

    clone(): ActivityPriorityRequestCommand {
        const json = this.toJSON();
        let result = new ActivityPriorityRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateActivityPriorityCommand extends ActivityPriorityRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateActivityPriorityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityPriorityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateActivityPriorityCommand {
        const json = this.toJSON();
        let result = new CreateActivityPriorityCommand();
        result.init(json);
        return result;
    }
}

export class EditActivityPriorityCommand extends ActivityPriorityRequestCommand {
    idActivityPriority?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idActivityPriority = _data["idActivityPriority"];
        }
    }

    static fromJS(data: any): EditActivityPriorityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditActivityPriorityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivityPriority"] = this.idActivityPriority;
        super.toJSON(data);
        return data; 
    }

    clone(): EditActivityPriorityCommand {
        const json = this.toJSON();
        let result = new EditActivityPriorityCommand();
        result.init(json);
        return result;
    }
}

export class ReorderActivityPriorityCommand {
    ids?: number[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderActivityPriorityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderActivityPriorityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }

    clone(): ReorderActivityPriorityCommand {
        const json = this.toJSON();
        let result = new ReorderActivityPriorityCommand();
        result.init(json);
        return result;
    }
}

export class ActivityStatusRequestCommand {
    orderId?: number;
    idActivityArea?: number;
    idLanguage?: number;
    title?: string;
    isFinal?: boolean;
    isSuccess?: boolean;
    color?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.idActivityArea = _data["idActivityArea"];
            this.idLanguage = _data["idLanguage"];
            this.title = _data["title"];
            this.isFinal = _data["isFinal"];
            this.isSuccess = _data["isSuccess"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ActivityStatusRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityStatusRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["idActivityArea"] = this.idActivityArea;
        data["idLanguage"] = this.idLanguage;
        data["title"] = this.title;
        data["isFinal"] = this.isFinal;
        data["isSuccess"] = this.isSuccess;
        data["color"] = this.color;
        return data; 
    }

    clone(): ActivityStatusRequestCommand {
        const json = this.toJSON();
        let result = new ActivityStatusRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateActivityStatusCommand extends ActivityStatusRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateActivityStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateActivityStatusCommand {
        const json = this.toJSON();
        let result = new CreateActivityStatusCommand();
        result.init(json);
        return result;
    }
}

export class EditActivityStatusCommand extends ActivityStatusRequestCommand {
    idActivityStatus?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idActivityStatus = _data["idActivityStatus"];
        }
    }

    static fromJS(data: any): EditActivityStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditActivityStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivityStatus"] = this.idActivityStatus;
        super.toJSON(data);
        return data; 
    }

    clone(): EditActivityStatusCommand {
        const json = this.toJSON();
        let result = new EditActivityStatusCommand();
        result.init(json);
        return result;
    }
}

export class ReorderActivityStatusCommand {
    ids?: number[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderActivityStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderActivityStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }

    clone(): ReorderActivityStatusCommand {
        const json = this.toJSON();
        let result = new ReorderActivityStatusCommand();
        result.init(json);
        return result;
    }
}

export class ActivityTypeRequestCommand {
    orderId?: number;
    idActivityArea?: number;
    idLanguage?: number;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.idActivityArea = _data["idActivityArea"];
            this.idLanguage = _data["idLanguage"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): ActivityTypeRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTypeRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["idActivityArea"] = this.idActivityArea;
        data["idLanguage"] = this.idLanguage;
        data["title"] = this.title;
        return data; 
    }

    clone(): ActivityTypeRequestCommand {
        const json = this.toJSON();
        let result = new ActivityTypeRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateActivityTypeCommand extends ActivityTypeRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateActivityTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateActivityTypeCommand {
        const json = this.toJSON();
        let result = new CreateActivityTypeCommand();
        result.init(json);
        return result;
    }
}

export class EditActivityTypeCommand extends ActivityTypeRequestCommand {
    idActivityType?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idActivityType = _data["idActivityType"];
        }
    }

    static fromJS(data: any): EditActivityTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditActivityTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idActivityType"] = this.idActivityType;
        super.toJSON(data);
        return data; 
    }

    clone(): EditActivityTypeCommand {
        const json = this.toJSON();
        let result = new EditActivityTypeCommand();
        result.init(json);
        return result;
    }
}

export class ReorderActivityTypeCommand {
    ids?: number[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderActivityTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderActivityTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }

    clone(): ReorderActivityTypeCommand {
        const json = this.toJSON();
        let result = new ReorderActivityTypeCommand();
        result.init(json);
        return result;
    }
}

export class GetAppGroupsDtosQuery {

    init(_data?: any) {
    }

    static fromJS(data: any): GetAppGroupsDtosQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppGroupsDtosQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): GetAppGroupsDtosQuery {
        const json = this.toJSON();
        let result = new GetAppGroupsDtosQuery();
        result.init(json);
        return result;
    }
}

export class AppGroupsRequestCommand {
    name?: string;
    orderId?: number;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): AppGroupsRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AppGroupsRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["orderId"] = this.orderId;
        return data; 
    }

    clone(): AppGroupsRequestCommand {
        const json = this.toJSON();
        let result = new AppGroupsRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateAppGroupCommand extends AppGroupsRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateAppGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateAppGroupCommand {
        const json = this.toJSON();
        let result = new CreateAppGroupCommand();
        result.init(json);
        return result;
    }
}

export class EditAppGroupCommand extends AppGroupsRequestCommand {
    idAppGroup?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idAppGroup = _data["idAppGroup"];
        }
    }

    static fromJS(data: any): EditAppGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditAppGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppGroup"] = this.idAppGroup;
        super.toJSON(data);
        return data; 
    }

    clone(): EditAppGroupCommand {
        const json = this.toJSON();
        let result = new EditAppGroupCommand();
        result.init(json);
        return result;
    }
}

export class ReorderAppGroupCommand {
    ids?: number[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderAppGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderAppGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }

    clone(): ReorderAppGroupCommand {
        const json = this.toJSON();
        let result = new ReorderAppGroupCommand();
        result.init(json);
        return result;
    }
}

export class AppInterfaceRoleRequestCommand {
    idLanguage?: number;
    idAppInterface?: number;
    title?: string;
    canImportOrExport?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idAppInterface = _data["idAppInterface"];
            this.title = _data["title"];
            this.canImportOrExport = _data["canImportOrExport"];
        }
    }

    static fromJS(data: any): AppInterfaceRoleRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AppInterfaceRoleRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idAppInterface"] = this.idAppInterface;
        data["title"] = this.title;
        data["canImportOrExport"] = this.canImportOrExport;
        return data; 
    }

    clone(): AppInterfaceRoleRequestCommand {
        const json = this.toJSON();
        let result = new AppInterfaceRoleRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateAppInterfaceRoleCommand extends AppInterfaceRoleRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateAppInterfaceRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppInterfaceRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateAppInterfaceRoleCommand {
        const json = this.toJSON();
        let result = new CreateAppInterfaceRoleCommand();
        result.init(json);
        return result;
    }
}

export class EditAppInterfaceRoleCommand extends AppInterfaceRoleRequestCommand {
    idAppInterfaceRole?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idAppInterfaceRole = _data["idAppInterfaceRole"];
        }
    }

    static fromJS(data: any): EditAppInterfaceRoleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditAppInterfaceRoleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppInterfaceRole"] = this.idAppInterfaceRole;
        super.toJSON(data);
        return data; 
    }

    clone(): EditAppInterfaceRoleCommand {
        const json = this.toJSON();
        let result = new EditAppInterfaceRoleCommand();
        result.init(json);
        return result;
    }
}

export class AuthenticateModel {
    username?: string;
    password?: string;
    idAppInterface?: number;

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.idAppInterface = _data["idAppInterface"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["idAppInterface"] = this.idAppInterface;
        return data; 
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export class TryRecoverCommand {
    username?: string;

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): TryRecoverCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TryRecoverCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data; 
    }

    clone(): TryRecoverCommand {
        const json = this.toJSON();
        let result = new TryRecoverCommand();
        result.init(json);
        return result;
    }
}

export class RecoverCommand {
    token?: string;
    password?: string;

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): RecoverCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RecoverCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["password"] = this.password;
        return data; 
    }

    clone(): RecoverCommand {
        const json = this.toJSON();
        let result = new RecoverCommand();
        result.init(json);
        return result;
    }
}

export class UserRequestCommand {
    email?: string | undefined;
    name?: string;
    contactDefault?: string;
    contactOptional?: string;
    photo?: string;
    nationality?: string;
    dateBirth?: string | undefined;
    idParent?: number | undefined;
    idUserType?: number | undefined;
    appGroups?: number[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
            this.contactDefault = _data["contactDefault"];
            this.contactOptional = _data["contactOptional"];
            this.photo = _data["photo"];
            this.nationality = _data["nationality"];
            this.dateBirth = _data["dateBirth"];
            this.idParent = _data["idParent"];
            this.idUserType = _data["idUserType"];
            if (Array.isArray(_data["appGroups"])) {
                this.appGroups = [] as any;
                for (let item of _data["appGroups"])
                    this.appGroups!.push(item);
            }
        }
    }

    static fromJS(data: any): UserRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        data["contactDefault"] = this.contactDefault;
        data["contactOptional"] = this.contactOptional;
        data["photo"] = this.photo;
        data["nationality"] = this.nationality;
        data["dateBirth"] = this.dateBirth;
        data["idParent"] = this.idParent;
        data["idUserType"] = this.idUserType;
        if (Array.isArray(this.appGroups)) {
            data["appGroups"] = [];
            for (let item of this.appGroups)
                data["appGroups"].push(item);
        }
        return data; 
    }

    clone(): UserRequestCommand {
        const json = this.toJSON();
        let result = new UserRequestCommand();
        result.init(json);
        return result;
    }
}

export class EditUserCommand extends UserRequestCommand {
    idUser?: number;
    idEntity?: number | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUser = _data["idUser"];
            this.idEntity = _data["idEntity"];
        }
    }

    static fromJS(data: any): EditUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        data["idEntity"] = this.idEntity;
        super.toJSON(data);
        return data; 
    }

    clone(): EditUserCommand {
        const json = this.toJSON();
        let result = new EditUserCommand();
        result.init(json);
        return result;
    }
}

export class SecurityUserCommand {
    password?: string;

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): SecurityUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        return data; 
    }

    clone(): SecurityUserCommand {
        const json = this.toJSON();
        let result = new SecurityUserCommand();
        result.init(json);
        return result;
    }
}

export enum GetEntitiesDtosOrderOptions {
    NameAsc = 0,
    NameDesc = 1,
    FiscalIdNumberAsc = 2,
    FiscalIdNumberDesc = 3,
}

export class EntityRequestCommand {
    name?: string;
    fiscalIdNumber?: string;
    website?: string;
    notes?: string;
    photo?: string;
    isCompany?: boolean;
    idEntityGroup?: number | undefined;
    idEntityType?: number | undefined;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.fiscalIdNumber = _data["fiscalIdNumber"];
            this.website = _data["website"];
            this.notes = _data["notes"];
            this.photo = _data["photo"];
            this.isCompany = _data["isCompany"];
            this.idEntityGroup = _data["idEntityGroup"];
            this.idEntityType = _data["idEntityType"];
        }
    }

    static fromJS(data: any): EntityRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EntityRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fiscalIdNumber"] = this.fiscalIdNumber;
        data["website"] = this.website;
        data["notes"] = this.notes;
        data["photo"] = this.photo;
        data["isCompany"] = this.isCompany;
        data["idEntityGroup"] = this.idEntityGroup;
        data["idEntityType"] = this.idEntityType;
        return data; 
    }

    clone(): EntityRequestCommand {
        const json = this.toJSON();
        let result = new EntityRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateEntityCommand extends EntityRequestCommand {
    metadata?: MetadataConfigurationFieldSimple[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(MetadataConfigurationFieldSimple.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEntityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEntityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): CreateEntityCommand {
        const json = this.toJSON();
        let result = new CreateEntityCommand();
        result.init(json);
        return result;
    }
}

export class EditEntityCommand extends EntityRequestCommand {
    idEntity?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntity = _data["idEntity"];
        }
    }

    static fromJS(data: any): EditEntityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditEntityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntity"] = this.idEntity;
        super.toJSON(data);
        return data; 
    }

    clone(): EditEntityCommand {
        const json = this.toJSON();
        let result = new EditEntityCommand();
        result.init(json);
        return result;
    }
}

export class CreateEntityFileCommand {
    idEntity?: number;
    title?: string;
    filename?: string;
    isPublic?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idEntity = _data["idEntity"];
            this.title = _data["title"];
            this.filename = _data["filename"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): CreateEntityFileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEntityFileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntity"] = this.idEntity;
        data["title"] = this.title;
        data["filename"] = this.filename;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): CreateEntityFileCommand {
        const json = this.toJSON();
        let result = new CreateEntityFileCommand();
        result.init(json);
        return result;
    }
}

export enum EntityLogTypes {
    Created = 0,
    Edited = 1,
}

export class EditEntityFileCommand {
    idEntityFile?: number;
    title?: string;
    filename?: string;
    isPublic?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idEntityFile = _data["idEntityFile"];
            this.title = _data["title"];
            this.filename = _data["filename"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): EditEntityFileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditEntityFileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityFile"] = this.idEntityFile;
        data["title"] = this.title;
        data["filename"] = this.filename;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): EditEntityFileCommand {
        const json = this.toJSON();
        let result = new EditEntityFileCommand();
        result.init(json);
        return result;
    }
}

export class CreateEntityCommentCommand {
    idEntity?: number;
    message?: string;
    isPublic?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idEntity = _data["idEntity"];
            this.message = _data["message"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): CreateEntityCommentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEntityCommentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntity"] = this.idEntity;
        data["message"] = this.message;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): CreateEntityCommentCommand {
        const json = this.toJSON();
        let result = new CreateEntityCommentCommand();
        result.init(json);
        return result;
    }
}

export class EditEntityMetadataCommand {
    idEntity?: number;
    metadata?: MetadataConfigurationFieldSimple[];

    init(_data?: any) {
        if (_data) {
            this.idEntity = _data["idEntity"];
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(MetadataConfigurationFieldSimple.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditEntityMetadataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditEntityMetadataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntity"] = this.idEntity;
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item.toJSON());
        }
        return data; 
    }

    clone(): EditEntityMetadataCommand {
        const json = this.toJSON();
        let result = new EditEntityMetadataCommand();
        result.init(json);
        return result;
    }
}

export class EntityGroupRequestCommand {
    idLanguage?: number;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): EntityGroupRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EntityGroupRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["title"] = this.title;
        return data; 
    }

    clone(): EntityGroupRequestCommand {
        const json = this.toJSON();
        let result = new EntityGroupRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateEntityGroupCommand extends EntityGroupRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateEntityGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEntityGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateEntityGroupCommand {
        const json = this.toJSON();
        let result = new CreateEntityGroupCommand();
        result.init(json);
        return result;
    }
}

export class EditEntityGroupCommand extends EntityGroupRequestCommand {
    idEntityGroup?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntityGroup = _data["idEntityGroup"];
        }
    }

    static fromJS(data: any): EditEntityGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditEntityGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityGroup"] = this.idEntityGroup;
        super.toJSON(data);
        return data; 
    }

    clone(): EditEntityGroupCommand {
        const json = this.toJSON();
        let result = new EditEntityGroupCommand();
        result.init(json);
        return result;
    }
}

export class EntitySectorRequestCommand {
    idLanguage?: number;
    orderId?: number;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.orderId = _data["orderId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): EntitySectorRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EntitySectorRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["orderId"] = this.orderId;
        data["title"] = this.title;
        return data; 
    }

    clone(): EntitySectorRequestCommand {
        const json = this.toJSON();
        let result = new EntitySectorRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateEntitySectorCommand extends EntitySectorRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateEntitySectorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEntitySectorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateEntitySectorCommand {
        const json = this.toJSON();
        let result = new CreateEntitySectorCommand();
        result.init(json);
        return result;
    }
}

export class EditEntitySectorCommand extends EntitySectorRequestCommand {
    idEntitySector?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntitySector = _data["idEntitySector"];
        }
    }

    static fromJS(data: any): EditEntitySectorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditEntitySectorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntitySector"] = this.idEntitySector;
        super.toJSON(data);
        return data; 
    }

    clone(): EditEntitySectorCommand {
        const json = this.toJSON();
        let result = new EditEntitySectorCommand();
        result.init(json);
        return result;
    }
}

export class ReorderEntitySectorsCommand {
    ids?: number[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderEntitySectorsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderEntitySectorsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }

    clone(): ReorderEntitySectorsCommand {
        const json = this.toJSON();
        let result = new ReorderEntitySectorsCommand();
        result.init(json);
        return result;
    }
}

export class EntityTypeRequestCommand {
    idLanguage?: number;
    orderId?: number;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.orderId = _data["orderId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): EntityTypeRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EntityTypeRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["orderId"] = this.orderId;
        data["title"] = this.title;
        return data; 
    }

    clone(): EntityTypeRequestCommand {
        const json = this.toJSON();
        let result = new EntityTypeRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateEntityTypeCommand extends EntityTypeRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateEntityTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEntityTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateEntityTypeCommand {
        const json = this.toJSON();
        let result = new CreateEntityTypeCommand();
        result.init(json);
        return result;
    }
}

export class EditEntityTypeCommand extends EntityTypeRequestCommand {
    idEntityType?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntityType = _data["idEntityType"];
        }
    }

    static fromJS(data: any): EditEntityTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditEntityTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityType"] = this.idEntityType;
        super.toJSON(data);
        return data; 
    }

    clone(): EditEntityTypeCommand {
        const json = this.toJSON();
        let result = new EditEntityTypeCommand();
        result.init(json);
        return result;
    }
}

export class ReorderEntityTypesCommand {
    ids?: number[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderEntityTypesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderEntityTypesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }

    clone(): ReorderEntityTypesCommand {
        const json = this.toJSON();
        let result = new ReorderEntityTypesCommand();
        result.init(json);
        return result;
    }
}

export class EditEntityTypeMetadataGroupsConfigurationCommand {
    idLanguage?: number;
    idEntityType?: number;
    metadataGroups?: number[];

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idEntityType = _data["idEntityType"];
            if (Array.isArray(_data["metadataGroups"])) {
                this.metadataGroups = [] as any;
                for (let item of _data["metadataGroups"])
                    this.metadataGroups!.push(item);
            }
        }
    }

    static fromJS(data: any): EditEntityTypeMetadataGroupsConfigurationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditEntityTypeMetadataGroupsConfigurationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idEntityType"] = this.idEntityType;
        if (Array.isArray(this.metadataGroups)) {
            data["metadataGroups"] = [];
            for (let item of this.metadataGroups)
                data["metadataGroups"].push(item);
        }
        return data; 
    }

    clone(): EditEntityTypeMetadataGroupsConfigurationCommand {
        const json = this.toJSON();
        let result = new EditEntityTypeMetadataGroupsConfigurationCommand();
        result.init(json);
        return result;
    }
}

export class FeedbackAnswerRequestCommand {
    idFeedbackAnswer?: number;
    idFeedbackQuestion?: number;
    feedbackQuestion?: FeedbackQuestion;
    idFeedbackQuestionGroup?: number;
    feedbackQuestionGroup?: FeedbackQuestionGroup;
    idUserResponse?: number;
    userResponse?: User;
    idUserRequest?: number;
    userRequest?: User;
    answer?: string;
    idUserType?: number;
    userType?: UserType;
    idFeedbackType?: number;

    init(_data?: any) {
        if (_data) {
            this.idFeedbackAnswer = _data["idFeedbackAnswer"];
            this.idFeedbackQuestion = _data["idFeedbackQuestion"];
            this.feedbackQuestion = _data["feedbackQuestion"] ? FeedbackQuestion.fromJS(_data["feedbackQuestion"]) : <any>undefined;
            this.idFeedbackQuestionGroup = _data["idFeedbackQuestionGroup"];
            this.feedbackQuestionGroup = _data["feedbackQuestionGroup"] ? FeedbackQuestionGroup.fromJS(_data["feedbackQuestionGroup"]) : <any>undefined;
            this.idUserResponse = _data["idUserResponse"];
            this.userResponse = _data["userResponse"] ? User.fromJS(_data["userResponse"]) : <any>undefined;
            this.idUserRequest = _data["idUserRequest"];
            this.userRequest = _data["userRequest"] ? User.fromJS(_data["userRequest"]) : <any>undefined;
            this.answer = _data["answer"];
            this.idUserType = _data["idUserType"];
            this.userType = _data["userType"] ? UserType.fromJS(_data["userType"]) : <any>undefined;
            this.idFeedbackType = _data["idFeedbackType"];
        }
    }

    static fromJS(data: any): FeedbackAnswerRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackAnswerRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackAnswer"] = this.idFeedbackAnswer;
        data["idFeedbackQuestion"] = this.idFeedbackQuestion;
        data["feedbackQuestion"] = this.feedbackQuestion ? this.feedbackQuestion.toJSON() : <any>undefined;
        data["idFeedbackQuestionGroup"] = this.idFeedbackQuestionGroup;
        data["feedbackQuestionGroup"] = this.feedbackQuestionGroup ? this.feedbackQuestionGroup.toJSON() : <any>undefined;
        data["idUserResponse"] = this.idUserResponse;
        data["userResponse"] = this.userResponse ? this.userResponse.toJSON() : <any>undefined;
        data["idUserRequest"] = this.idUserRequest;
        data["userRequest"] = this.userRequest ? this.userRequest.toJSON() : <any>undefined;
        data["answer"] = this.answer;
        data["idUserType"] = this.idUserType;
        data["userType"] = this.userType ? this.userType.toJSON() : <any>undefined;
        data["idFeedbackType"] = this.idFeedbackType;
        return data; 
    }

    clone(): FeedbackAnswerRequestCommand {
        const json = this.toJSON();
        let result = new FeedbackAnswerRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateFeedbackAnswerCommand extends FeedbackAnswerRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateFeedbackAnswerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFeedbackAnswerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateFeedbackAnswerCommand {
        const json = this.toJSON();
        let result = new CreateFeedbackAnswerCommand();
        result.init(json);
        return result;
    }
}

export abstract class AuditableEntity {
    createdBy?: string | undefined;
    dateCreated?: string;
    lastModifiedBy?: string | undefined;
    dateUpdated?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["createdBy"];
            this.dateCreated = _data["dateCreated"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.dateUpdated = _data["dateUpdated"];
        }
    }

    static fromJS(data: any): AuditableEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AuditableEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy;
        data["dateCreated"] = this.dateCreated;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["dateUpdated"] = this.dateUpdated;
        return data; 
    }

    clone(): AuditableEntity {
        throw new Error("The abstract class 'AuditableEntity' cannot be instantiated.");
    }
}

export class FeedbackQuestion extends AuditableEntity {
    idFeedbackQuestion?: number;
    idFeedbackQuestionGroup?: number;
    feedbackQuestionGroup?: FeedbackQuestionGroup;
    orderId?: number;
    idFeedbackQuestionType?: number;
    feedbackQuestionType?: FeedbackQuestionType;
    reflection?: number;
    title?: string;
    description?: string | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackQuestion = _data["idFeedbackQuestion"];
            this.idFeedbackQuestionGroup = _data["idFeedbackQuestionGroup"];
            this.feedbackQuestionGroup = _data["feedbackQuestionGroup"] ? FeedbackQuestionGroup.fromJS(_data["feedbackQuestionGroup"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.idFeedbackQuestionType = _data["idFeedbackQuestionType"];
            this.feedbackQuestionType = _data["feedbackQuestionType"] ? FeedbackQuestionType.fromJS(_data["feedbackQuestionType"]) : <any>undefined;
            this.reflection = _data["reflection"];
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FeedbackQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackQuestion"] = this.idFeedbackQuestion;
        data["idFeedbackQuestionGroup"] = this.idFeedbackQuestionGroup;
        data["feedbackQuestionGroup"] = this.feedbackQuestionGroup ? this.feedbackQuestionGroup.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["idFeedbackQuestionType"] = this.idFeedbackQuestionType;
        data["feedbackQuestionType"] = this.feedbackQuestionType ? this.feedbackQuestionType.toJSON() : <any>undefined;
        data["reflection"] = this.reflection;
        data["title"] = this.title;
        data["description"] = this.description;
        super.toJSON(data);
        return data; 
    }

    clone(): FeedbackQuestion {
        const json = this.toJSON();
        let result = new FeedbackQuestion();
        result.init(json);
        return result;
    }
}

export class FeedbackQuestionGroup extends AuditableEntity {
    idFeedbackQuestionGroup?: number;
    idFeedback?: number;
    feedback?: Feedback;
    title?: string;
    sendToStatistics?: boolean;
    reflection?: number;
    orderId?: number;
    feedbackQuestions?: FeedbackQuestion[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackQuestionGroup = _data["idFeedbackQuestionGroup"];
            this.idFeedback = _data["idFeedback"];
            this.feedback = _data["feedback"] ? Feedback.fromJS(_data["feedback"]) : <any>undefined;
            this.title = _data["title"];
            this.sendToStatistics = _data["sendToStatistics"];
            this.reflection = _data["reflection"];
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["feedbackQuestions"])) {
                this.feedbackQuestions = [] as any;
                for (let item of _data["feedbackQuestions"])
                    this.feedbackQuestions!.push(FeedbackQuestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeedbackQuestionGroup {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackQuestionGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackQuestionGroup"] = this.idFeedbackQuestionGroup;
        data["idFeedback"] = this.idFeedback;
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["sendToStatistics"] = this.sendToStatistics;
        data["reflection"] = this.reflection;
        data["orderId"] = this.orderId;
        if (Array.isArray(this.feedbackQuestions)) {
            data["feedbackQuestions"] = [];
            for (let item of this.feedbackQuestions)
                data["feedbackQuestions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): FeedbackQuestionGroup {
        const json = this.toJSON();
        let result = new FeedbackQuestionGroup();
        result.init(json);
        return result;
    }
}

export class Feedback extends AuditableEntity {
    idFeedback?: number;
    idFeedbackType?: number | undefined;
    feedbackType?: FeedbackType | undefined;
    idUser?: number | undefined;
    user?: User | undefined;
    title?: string;
    description?: string | undefined;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
    resolved?: boolean;
    feedbackQuestionGroups?: FeedbackQuestionGroup[];
    appGroupVsFeedbacks?: AppGroupVsFeedback[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedback = _data["idFeedback"];
            this.idFeedbackType = _data["idFeedbackType"];
            this.feedbackType = _data["feedbackType"] ? FeedbackType.fromJS(_data["feedbackType"]) : <any>undefined;
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.dateStart = _data["dateStart"];
            this.dateEnd = _data["dateEnd"];
            this.resolved = _data["resolved"];
            if (Array.isArray(_data["feedbackQuestionGroups"])) {
                this.feedbackQuestionGroups = [] as any;
                for (let item of _data["feedbackQuestionGroups"])
                    this.feedbackQuestionGroups!.push(FeedbackQuestionGroup.fromJS(item));
            }
            if (Array.isArray(_data["appGroupVsFeedbacks"])) {
                this.appGroupVsFeedbacks = [] as any;
                for (let item of _data["appGroupVsFeedbacks"])
                    this.appGroupVsFeedbacks!.push(AppGroupVsFeedback.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Feedback {
        data = typeof data === 'object' ? data : {};
        let result = new Feedback();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedback"] = this.idFeedback;
        data["idFeedbackType"] = this.idFeedbackType;
        data["feedbackType"] = this.feedbackType ? this.feedbackType.toJSON() : <any>undefined;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["dateStart"] = this.dateStart;
        data["dateEnd"] = this.dateEnd;
        data["resolved"] = this.resolved;
        if (Array.isArray(this.feedbackQuestionGroups)) {
            data["feedbackQuestionGroups"] = [];
            for (let item of this.feedbackQuestionGroups)
                data["feedbackQuestionGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.appGroupVsFeedbacks)) {
            data["appGroupVsFeedbacks"] = [];
            for (let item of this.appGroupVsFeedbacks)
                data["appGroupVsFeedbacks"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): Feedback {
        const json = this.toJSON();
        let result = new Feedback();
        result.init(json);
        return result;
    }
}

export class FeedbackType extends AuditableEntity {
    idFeedbackType?: number;
    title?: string;
    icon?: string | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackType = _data["idFeedbackType"];
            this.title = _data["title"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): FeedbackType {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackType"] = this.idFeedbackType;
        data["title"] = this.title;
        data["icon"] = this.icon;
        super.toJSON(data);
        return data; 
    }

    clone(): FeedbackType {
        const json = this.toJSON();
        let result = new FeedbackType();
        result.init(json);
        return result;
    }
}

export abstract class OwnerEntity extends AuditableEntity {
    idOwner?: number | undefined;
    owner?: User | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idOwner = _data["idOwner"];
            this.owner = _data["owner"] ? User.fromJS(_data["owner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OwnerEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OwnerEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idOwner"] = this.idOwner;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): OwnerEntity {
        throw new Error("The abstract class 'OwnerEntity' cannot be instantiated.");
    }
}

export class User extends OwnerEntity {
    idUser?: number;
    name?: string;
    email?: string | undefined;
    contactDefault?: string | undefined;
    contactOptional?: string | undefined;
    idParent?: number | undefined;
    parent?: User | undefined;
    idUserType?: number | undefined;
    userType?: UserType | undefined;
    idEntity?: number | undefined;
    entity?: Entity | undefined;
    path?: string | undefined;
    photo?: string | undefined;
    nationality?: string | undefined;
    dateBirth?: string | undefined;
    appGroups?: UserVsAppGroup[];
    descendents?: User[];
    userLogins?: UserLogin[];
    userMetadata?: UserMetadata[];
    comments?: UserComment[];
    logs?: UserLog[];
    feedbacks?: Feedback[];
    concludedFeedbacks?: FeedbackVsUser[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUser = _data["idUser"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.contactDefault = _data["contactDefault"];
            this.contactOptional = _data["contactOptional"];
            this.idParent = _data["idParent"];
            this.parent = _data["parent"] ? User.fromJS(_data["parent"]) : <any>undefined;
            this.idUserType = _data["idUserType"];
            this.userType = _data["userType"] ? UserType.fromJS(_data["userType"]) : <any>undefined;
            this.idEntity = _data["idEntity"];
            this.entity = _data["entity"] ? Entity.fromJS(_data["entity"]) : <any>undefined;
            this.path = _data["path"];
            this.photo = _data["photo"];
            this.nationality = _data["nationality"];
            this.dateBirth = _data["dateBirth"];
            if (Array.isArray(_data["appGroups"])) {
                this.appGroups = [] as any;
                for (let item of _data["appGroups"])
                    this.appGroups!.push(UserVsAppGroup.fromJS(item));
            }
            if (Array.isArray(_data["descendents"])) {
                this.descendents = [] as any;
                for (let item of _data["descendents"])
                    this.descendents!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["userLogins"])) {
                this.userLogins = [] as any;
                for (let item of _data["userLogins"])
                    this.userLogins!.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["userMetadata"])) {
                this.userMetadata = [] as any;
                for (let item of _data["userMetadata"])
                    this.userMetadata!.push(UserMetadata.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(UserComment.fromJS(item));
            }
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(UserLog.fromJS(item));
            }
            if (Array.isArray(_data["feedbacks"])) {
                this.feedbacks = [] as any;
                for (let item of _data["feedbacks"])
                    this.feedbacks!.push(Feedback.fromJS(item));
            }
            if (Array.isArray(_data["concludedFeedbacks"])) {
                this.concludedFeedbacks = [] as any;
                for (let item of _data["concludedFeedbacks"])
                    this.concludedFeedbacks!.push(FeedbackVsUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        data["name"] = this.name;
        data["email"] = this.email;
        data["contactDefault"] = this.contactDefault;
        data["contactOptional"] = this.contactOptional;
        data["idParent"] = this.idParent;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["idUserType"] = this.idUserType;
        data["userType"] = this.userType ? this.userType.toJSON() : <any>undefined;
        data["idEntity"] = this.idEntity;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["path"] = this.path;
        data["photo"] = this.photo;
        data["nationality"] = this.nationality;
        data["dateBirth"] = this.dateBirth;
        if (Array.isArray(this.appGroups)) {
            data["appGroups"] = [];
            for (let item of this.appGroups)
                data["appGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.descendents)) {
            data["descendents"] = [];
            for (let item of this.descendents)
                data["descendents"].push(item.toJSON());
        }
        if (Array.isArray(this.userLogins)) {
            data["userLogins"] = [];
            for (let item of this.userLogins)
                data["userLogins"].push(item.toJSON());
        }
        if (Array.isArray(this.userMetadata)) {
            data["userMetadata"] = [];
            for (let item of this.userMetadata)
                data["userMetadata"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        if (Array.isArray(this.feedbacks)) {
            data["feedbacks"] = [];
            for (let item of this.feedbacks)
                data["feedbacks"].push(item.toJSON());
        }
        if (Array.isArray(this.concludedFeedbacks)) {
            data["concludedFeedbacks"] = [];
            for (let item of this.concludedFeedbacks)
                data["concludedFeedbacks"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export class UserType extends AuditableEntity {
    idUserType?: number;
    orderId?: number;
    userTypeAttrs?: UserTypeAttr[];
    userTypeVsMetadataGroups?: UserTypeVsMetadataGroup[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserType = _data["idUserType"];
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["userTypeAttrs"])) {
                this.userTypeAttrs = [] as any;
                for (let item of _data["userTypeAttrs"])
                    this.userTypeAttrs!.push(UserTypeAttr.fromJS(item));
            }
            if (Array.isArray(_data["userTypeVsMetadataGroups"])) {
                this.userTypeVsMetadataGroups = [] as any;
                for (let item of _data["userTypeVsMetadataGroups"])
                    this.userTypeVsMetadataGroups!.push(UserTypeVsMetadataGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserType {
        data = typeof data === 'object' ? data : {};
        let result = new UserType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserType"] = this.idUserType;
        data["orderId"] = this.orderId;
        if (Array.isArray(this.userTypeAttrs)) {
            data["userTypeAttrs"] = [];
            for (let item of this.userTypeAttrs)
                data["userTypeAttrs"].push(item.toJSON());
        }
        if (Array.isArray(this.userTypeVsMetadataGroups)) {
            data["userTypeVsMetadataGroups"] = [];
            for (let item of this.userTypeVsMetadataGroups)
                data["userTypeVsMetadataGroups"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): UserType {
        const json = this.toJSON();
        let result = new UserType();
        result.init(json);
        return result;
    }
}

export class UserTypeAttr {
    idUserType?: number;
    userType?: UserType;
    idLanguage?: number;
    language?: Language;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idUserType = _data["idUserType"];
            this.userType = _data["userType"] ? UserType.fromJS(_data["userType"]) : <any>undefined;
            this.idLanguage = _data["idLanguage"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UserTypeAttr {
        data = typeof data === 'object' ? data : {};
        let result = new UserTypeAttr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserType"] = this.idUserType;
        data["userType"] = this.userType ? this.userType.toJSON() : <any>undefined;
        data["idLanguage"] = this.idLanguage;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["title"] = this.title;
        return data; 
    }

    clone(): UserTypeAttr {
        const json = this.toJSON();
        let result = new UserTypeAttr();
        result.init(json);
        return result;
    }
}

export class Language extends AuditableEntity {
    idLanguage?: number;
    name?: string;
    reference?: string;
    code?: string;
    direction?: string;
    isDefault?: boolean;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.name = _data["name"];
            this.reference = _data["reference"];
            this.code = _data["code"];
            this.direction = _data["direction"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["name"] = this.name;
        data["reference"] = this.reference;
        data["code"] = this.code;
        data["direction"] = this.direction;
        data["isDefault"] = this.isDefault;
        super.toJSON(data);
        return data; 
    }

    clone(): Language {
        const json = this.toJSON();
        let result = new Language();
        result.init(json);
        return result;
    }
}

export class UserTypeVsMetadataGroup extends AuditableEntity {
    idMetadataGroup?: number;
    metadataGroup?: MetadataGroup;
    idUserType?: number;
    userType?: UserType;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idMetadataGroup = _data["idMetadataGroup"];
            this.metadataGroup = _data["metadataGroup"] ? MetadataGroup.fromJS(_data["metadataGroup"]) : <any>undefined;
            this.idUserType = _data["idUserType"];
            this.userType = _data["userType"] ? UserType.fromJS(_data["userType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserTypeVsMetadataGroup {
        data = typeof data === 'object' ? data : {};
        let result = new UserTypeVsMetadataGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataGroup"] = this.idMetadataGroup;
        data["metadataGroup"] = this.metadataGroup ? this.metadataGroup.toJSON() : <any>undefined;
        data["idUserType"] = this.idUserType;
        data["userType"] = this.userType ? this.userType.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): UserTypeVsMetadataGroup {
        const json = this.toJSON();
        let result = new UserTypeVsMetadataGroup();
        result.init(json);
        return result;
    }
}

export class MetadataGroup extends AuditableEntity {
    idMetadataGroup?: number;
    orderId?: number;
    visibleOnCreate?: boolean;
    metadataGroupAttrs?: MetadataGroupAttr[];
    metadataFields?: MetadataField[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idMetadataGroup = _data["idMetadataGroup"];
            this.orderId = _data["orderId"];
            this.visibleOnCreate = _data["visibleOnCreate"];
            if (Array.isArray(_data["metadataGroupAttrs"])) {
                this.metadataGroupAttrs = [] as any;
                for (let item of _data["metadataGroupAttrs"])
                    this.metadataGroupAttrs!.push(MetadataGroupAttr.fromJS(item));
            }
            if (Array.isArray(_data["metadataFields"])) {
                this.metadataFields = [] as any;
                for (let item of _data["metadataFields"])
                    this.metadataFields!.push(MetadataField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MetadataGroup {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataGroup"] = this.idMetadataGroup;
        data["orderId"] = this.orderId;
        data["visibleOnCreate"] = this.visibleOnCreate;
        if (Array.isArray(this.metadataGroupAttrs)) {
            data["metadataGroupAttrs"] = [];
            for (let item of this.metadataGroupAttrs)
                data["metadataGroupAttrs"].push(item.toJSON());
        }
        if (Array.isArray(this.metadataFields)) {
            data["metadataFields"] = [];
            for (let item of this.metadataFields)
                data["metadataFields"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): MetadataGroup {
        const json = this.toJSON();
        let result = new MetadataGroup();
        result.init(json);
        return result;
    }
}

export class MetadataGroupAttr {
    idMetadataGroup?: number;
    metadataGroup?: MetadataGroup;
    idLanguage?: number;
    language?: Language;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idMetadataGroup = _data["idMetadataGroup"];
            this.metadataGroup = _data["metadataGroup"] ? MetadataGroup.fromJS(_data["metadataGroup"]) : <any>undefined;
            this.idLanguage = _data["idLanguage"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): MetadataGroupAttr {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataGroupAttr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataGroup"] = this.idMetadataGroup;
        data["metadataGroup"] = this.metadataGroup ? this.metadataGroup.toJSON() : <any>undefined;
        data["idLanguage"] = this.idLanguage;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["title"] = this.title;
        return data; 
    }

    clone(): MetadataGroupAttr {
        const json = this.toJSON();
        let result = new MetadataGroupAttr();
        result.init(json);
        return result;
    }
}

export class MetadataField extends AuditableEntity {
    idMetadataField?: number;
    idMetadataGroup?: number;
    metadataGroup?: MetadataGroup;
    orderId?: number;
    reference?: string;
    default?: string | undefined;
    photo?: string | undefined;
    validation?: string | undefined;
    isRequired?: boolean;
    typeId?: MetadataFieldTypes;
    metadataFieldAttrs?: MetadataFieldAttr[];
    metadataFieldOptions?: MetadataFieldOption[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idMetadataField = _data["idMetadataField"];
            this.idMetadataGroup = _data["idMetadataGroup"];
            this.metadataGroup = _data["metadataGroup"] ? MetadataGroup.fromJS(_data["metadataGroup"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.reference = _data["reference"];
            this.default = _data["default"];
            this.photo = _data["photo"];
            this.validation = _data["validation"];
            this.isRequired = _data["isRequired"];
            this.typeId = _data["typeId"];
            if (Array.isArray(_data["metadataFieldAttrs"])) {
                this.metadataFieldAttrs = [] as any;
                for (let item of _data["metadataFieldAttrs"])
                    this.metadataFieldAttrs!.push(MetadataFieldAttr.fromJS(item));
            }
            if (Array.isArray(_data["metadataFieldOptions"])) {
                this.metadataFieldOptions = [] as any;
                for (let item of _data["metadataFieldOptions"])
                    this.metadataFieldOptions!.push(MetadataFieldOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MetadataField {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataField"] = this.idMetadataField;
        data["idMetadataGroup"] = this.idMetadataGroup;
        data["metadataGroup"] = this.metadataGroup ? this.metadataGroup.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["reference"] = this.reference;
        data["default"] = this.default;
        data["photo"] = this.photo;
        data["validation"] = this.validation;
        data["isRequired"] = this.isRequired;
        data["typeId"] = this.typeId;
        if (Array.isArray(this.metadataFieldAttrs)) {
            data["metadataFieldAttrs"] = [];
            for (let item of this.metadataFieldAttrs)
                data["metadataFieldAttrs"].push(item.toJSON());
        }
        if (Array.isArray(this.metadataFieldOptions)) {
            data["metadataFieldOptions"] = [];
            for (let item of this.metadataFieldOptions)
                data["metadataFieldOptions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): MetadataField {
        const json = this.toJSON();
        let result = new MetadataField();
        result.init(json);
        return result;
    }
}

export enum MetadataFieldTypes {
    Text = 1,
    Html = 2,
    Date = 3,
    Time = 4,
    Datetime = 5,
    Integer = 6,
    Decimal = 7,
    Currency = 8,
    GpsCoordinates = 9,
    SelectorSingle = 10,
    SelectorMultiple = 11,
    File = 12,
    Boolean = 13,
}

export class MetadataFieldAttr {
    idMetadataField?: number;
    metadataField?: MetadataField;
    idLanguage?: number;
    language?: Language;
    title?: string;
    description?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.idMetadataField = _data["idMetadataField"];
            this.metadataField = _data["metadataField"] ? MetadataField.fromJS(_data["metadataField"]) : <any>undefined;
            this.idLanguage = _data["idLanguage"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): MetadataFieldAttr {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataFieldAttr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataField"] = this.idMetadataField;
        data["metadataField"] = this.metadataField ? this.metadataField.toJSON() : <any>undefined;
        data["idLanguage"] = this.idLanguage;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        return data; 
    }

    clone(): MetadataFieldAttr {
        const json = this.toJSON();
        let result = new MetadataFieldAttr();
        result.init(json);
        return result;
    }
}

export class MetadataFieldOption extends AuditableEntity {
    idMetadataFieldOption?: number;
    idMetadataField?: number;
    metadataField?: MetadataField;
    orderId?: number;
    photo?: string | undefined;
    metadataFieldOptionAttrs?: MetadataFieldOptionAttr[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idMetadataFieldOption = _data["idMetadataFieldOption"];
            this.idMetadataField = _data["idMetadataField"];
            this.metadataField = _data["metadataField"] ? MetadataField.fromJS(_data["metadataField"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.photo = _data["photo"];
            if (Array.isArray(_data["metadataFieldOptionAttrs"])) {
                this.metadataFieldOptionAttrs = [] as any;
                for (let item of _data["metadataFieldOptionAttrs"])
                    this.metadataFieldOptionAttrs!.push(MetadataFieldOptionAttr.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MetadataFieldOption {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataFieldOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataFieldOption"] = this.idMetadataFieldOption;
        data["idMetadataField"] = this.idMetadataField;
        data["metadataField"] = this.metadataField ? this.metadataField.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["photo"] = this.photo;
        if (Array.isArray(this.metadataFieldOptionAttrs)) {
            data["metadataFieldOptionAttrs"] = [];
            for (let item of this.metadataFieldOptionAttrs)
                data["metadataFieldOptionAttrs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): MetadataFieldOption {
        const json = this.toJSON();
        let result = new MetadataFieldOption();
        result.init(json);
        return result;
    }
}

export class MetadataFieldOptionAttr {
    idMetadataFieldOption?: number;
    metadataFieldOption?: MetadataFieldOption;
    idLanguage?: number;
    language?: Language;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idMetadataFieldOption = _data["idMetadataFieldOption"];
            this.metadataFieldOption = _data["metadataFieldOption"] ? MetadataFieldOption.fromJS(_data["metadataFieldOption"]) : <any>undefined;
            this.idLanguage = _data["idLanguage"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): MetadataFieldOptionAttr {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataFieldOptionAttr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataFieldOption"] = this.idMetadataFieldOption;
        data["metadataFieldOption"] = this.metadataFieldOption ? this.metadataFieldOption.toJSON() : <any>undefined;
        data["idLanguage"] = this.idLanguage;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["title"] = this.title;
        return data; 
    }

    clone(): MetadataFieldOptionAttr {
        const json = this.toJSON();
        let result = new MetadataFieldOptionAttr();
        result.init(json);
        return result;
    }
}

export class Entity extends OwnerEntity {
    idEntity?: number;
    name?: string;
    fiscalIdNumber?: string;
    website?: string | undefined;
    notes?: string | undefined;
    photo?: string | undefined;
    isCompany?: boolean;
    idEntityGroup?: number | undefined;
    entityGroup?: EntityGroup | undefined;
    idEntityType?: number | undefined;
    entityType?: EntityType | undefined;
    files?: EntityFile[];
    users?: User[];
    comments?: EntityComment[];
    logs?: EntityLog[];
    entityMetadata?: EntityMetadata[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntity = _data["idEntity"];
            this.name = _data["name"];
            this.fiscalIdNumber = _data["fiscalIdNumber"];
            this.website = _data["website"];
            this.notes = _data["notes"];
            this.photo = _data["photo"];
            this.isCompany = _data["isCompany"];
            this.idEntityGroup = _data["idEntityGroup"];
            this.entityGroup = _data["entityGroup"] ? EntityGroup.fromJS(_data["entityGroup"]) : <any>undefined;
            this.idEntityType = _data["idEntityType"];
            this.entityType = _data["entityType"] ? EntityType.fromJS(_data["entityType"]) : <any>undefined;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(EntityFile.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(EntityComment.fromJS(item));
            }
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(EntityLog.fromJS(item));
            }
            if (Array.isArray(_data["entityMetadata"])) {
                this.entityMetadata = [] as any;
                for (let item of _data["entityMetadata"])
                    this.entityMetadata!.push(EntityMetadata.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Entity {
        data = typeof data === 'object' ? data : {};
        let result = new Entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntity"] = this.idEntity;
        data["name"] = this.name;
        data["fiscalIdNumber"] = this.fiscalIdNumber;
        data["website"] = this.website;
        data["notes"] = this.notes;
        data["photo"] = this.photo;
        data["isCompany"] = this.isCompany;
        data["idEntityGroup"] = this.idEntityGroup;
        data["entityGroup"] = this.entityGroup ? this.entityGroup.toJSON() : <any>undefined;
        data["idEntityType"] = this.idEntityType;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        if (Array.isArray(this.entityMetadata)) {
            data["entityMetadata"] = [];
            for (let item of this.entityMetadata)
                data["entityMetadata"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): Entity {
        const json = this.toJSON();
        let result = new Entity();
        result.init(json);
        return result;
    }
}

export class EntityGroup extends AuditableEntity {
    idEntityGroup?: number;
    entityGroupAttrs?: EntityGroupAttr[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntityGroup = _data["idEntityGroup"];
            if (Array.isArray(_data["entityGroupAttrs"])) {
                this.entityGroupAttrs = [] as any;
                for (let item of _data["entityGroupAttrs"])
                    this.entityGroupAttrs!.push(EntityGroupAttr.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityGroup {
        data = typeof data === 'object' ? data : {};
        let result = new EntityGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityGroup"] = this.idEntityGroup;
        if (Array.isArray(this.entityGroupAttrs)) {
            data["entityGroupAttrs"] = [];
            for (let item of this.entityGroupAttrs)
                data["entityGroupAttrs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): EntityGroup {
        const json = this.toJSON();
        let result = new EntityGroup();
        result.init(json);
        return result;
    }
}

export class EntityGroupAttr {
    idEntityGroup?: number;
    entityGroup?: EntityGroup;
    idLanguage?: number;
    language?: Language;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idEntityGroup = _data["idEntityGroup"];
            this.entityGroup = _data["entityGroup"] ? EntityGroup.fromJS(_data["entityGroup"]) : <any>undefined;
            this.idLanguage = _data["idLanguage"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): EntityGroupAttr {
        data = typeof data === 'object' ? data : {};
        let result = new EntityGroupAttr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityGroup"] = this.idEntityGroup;
        data["entityGroup"] = this.entityGroup ? this.entityGroup.toJSON() : <any>undefined;
        data["idLanguage"] = this.idLanguage;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["title"] = this.title;
        return data; 
    }

    clone(): EntityGroupAttr {
        const json = this.toJSON();
        let result = new EntityGroupAttr();
        result.init(json);
        return result;
    }
}

export class EntityType extends AuditableEntity {
    idEntityType?: number;
    orderId?: number;
    entityTypeAttrs?: EntityTypeAttr[];
    entityTypeVsMetadataGroups?: EntityTypeVsMetadataGroup[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntityType = _data["idEntityType"];
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["entityTypeAttrs"])) {
                this.entityTypeAttrs = [] as any;
                for (let item of _data["entityTypeAttrs"])
                    this.entityTypeAttrs!.push(EntityTypeAttr.fromJS(item));
            }
            if (Array.isArray(_data["entityTypeVsMetadataGroups"])) {
                this.entityTypeVsMetadataGroups = [] as any;
                for (let item of _data["entityTypeVsMetadataGroups"])
                    this.entityTypeVsMetadataGroups!.push(EntityTypeVsMetadataGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityType {
        data = typeof data === 'object' ? data : {};
        let result = new EntityType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityType"] = this.idEntityType;
        data["orderId"] = this.orderId;
        if (Array.isArray(this.entityTypeAttrs)) {
            data["entityTypeAttrs"] = [];
            for (let item of this.entityTypeAttrs)
                data["entityTypeAttrs"].push(item.toJSON());
        }
        if (Array.isArray(this.entityTypeVsMetadataGroups)) {
            data["entityTypeVsMetadataGroups"] = [];
            for (let item of this.entityTypeVsMetadataGroups)
                data["entityTypeVsMetadataGroups"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): EntityType {
        const json = this.toJSON();
        let result = new EntityType();
        result.init(json);
        return result;
    }
}

export class EntityTypeAttr {
    idEntityType?: number;
    entityType?: EntityType;
    idLanguage?: number;
    language?: Language;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idEntityType = _data["idEntityType"];
            this.entityType = _data["entityType"] ? EntityType.fromJS(_data["entityType"]) : <any>undefined;
            this.idLanguage = _data["idLanguage"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): EntityTypeAttr {
        data = typeof data === 'object' ? data : {};
        let result = new EntityTypeAttr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityType"] = this.idEntityType;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : <any>undefined;
        data["idLanguage"] = this.idLanguage;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["title"] = this.title;
        return data; 
    }

    clone(): EntityTypeAttr {
        const json = this.toJSON();
        let result = new EntityTypeAttr();
        result.init(json);
        return result;
    }
}

export class EntityTypeVsMetadataGroup extends AuditableEntity {
    idMetadataGroup?: number;
    metadataGroup?: MetadataGroup;
    idEntityType?: number;
    entityType?: EntityType;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idMetadataGroup = _data["idMetadataGroup"];
            this.metadataGroup = _data["metadataGroup"] ? MetadataGroup.fromJS(_data["metadataGroup"]) : <any>undefined;
            this.idEntityType = _data["idEntityType"];
            this.entityType = _data["entityType"] ? EntityType.fromJS(_data["entityType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityTypeVsMetadataGroup {
        data = typeof data === 'object' ? data : {};
        let result = new EntityTypeVsMetadataGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataGroup"] = this.idMetadataGroup;
        data["metadataGroup"] = this.metadataGroup ? this.metadataGroup.toJSON() : <any>undefined;
        data["idEntityType"] = this.idEntityType;
        data["entityType"] = this.entityType ? this.entityType.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): EntityTypeVsMetadataGroup {
        const json = this.toJSON();
        let result = new EntityTypeVsMetadataGroup();
        result.init(json);
        return result;
    }
}

export class EntityFile extends AuditableEntity {
    idEntityFile?: number;
    idEntity?: number | undefined;
    entity?: Entity | undefined;
    idUser?: number | undefined;
    user?: User | undefined;
    filename?: string;
    isPublic?: boolean;
    title?: string;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntityFile = _data["idEntityFile"];
            this.idEntity = _data["idEntity"];
            this.entity = _data["entity"] ? Entity.fromJS(_data["entity"]) : <any>undefined;
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.filename = _data["filename"];
            this.isPublic = _data["isPublic"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): EntityFile {
        data = typeof data === 'object' ? data : {};
        let result = new EntityFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityFile"] = this.idEntityFile;
        data["idEntity"] = this.idEntity;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["filename"] = this.filename;
        data["isPublic"] = this.isPublic;
        data["title"] = this.title;
        super.toJSON(data);
        return data; 
    }

    clone(): EntityFile {
        const json = this.toJSON();
        let result = new EntityFile();
        result.init(json);
        return result;
    }
}

export class EntityComment extends AuditableEntity {
    idEntityComment?: number;
    idEntity?: number;
    entity?: Entity;
    idUser?: number | undefined;
    user?: User | undefined;
    message?: string;
    isPublic?: boolean;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntityComment = _data["idEntityComment"];
            this.idEntity = _data["idEntity"];
            this.entity = _data["entity"] ? Entity.fromJS(_data["entity"]) : <any>undefined;
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.message = _data["message"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): EntityComment {
        data = typeof data === 'object' ? data : {};
        let result = new EntityComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityComment"] = this.idEntityComment;
        data["idEntity"] = this.idEntity;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["isPublic"] = this.isPublic;
        super.toJSON(data);
        return data; 
    }

    clone(): EntityComment {
        const json = this.toJSON();
        let result = new EntityComment();
        result.init(json);
        return result;
    }
}

export class EntityLog extends AuditableEntity {
    idEntityLog?: number;
    idEntity?: number;
    entity?: Entity;
    description?: string | undefined;
    typeId?: EntityLogTypes;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntityLog = _data["idEntityLog"];
            this.idEntity = _data["idEntity"];
            this.entity = _data["entity"] ? Entity.fromJS(_data["entity"]) : <any>undefined;
            this.description = _data["description"];
            this.typeId = _data["typeId"];
        }
    }

    static fromJS(data: any): EntityLog {
        data = typeof data === 'object' ? data : {};
        let result = new EntityLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityLog"] = this.idEntityLog;
        data["idEntity"] = this.idEntity;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["typeId"] = this.typeId;
        super.toJSON(data);
        return data; 
    }

    clone(): EntityLog {
        const json = this.toJSON();
        let result = new EntityLog();
        result.init(json);
        return result;
    }
}

export class Metadata extends AuditableEntity {
    idMetadataField?: number;
    metadataField?: MetadataField;
    value?: string | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idMetadataField = _data["idMetadataField"];
            this.metadataField = _data["metadataField"] ? MetadataField.fromJS(_data["metadataField"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Metadata {
        data = typeof data === 'object' ? data : {};
        let result = new Metadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataField"] = this.idMetadataField;
        data["metadataField"] = this.metadataField ? this.metadataField.toJSON() : <any>undefined;
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }

    clone(): Metadata {
        const json = this.toJSON();
        let result = new Metadata();
        result.init(json);
        return result;
    }
}

export class EntityMetadata extends Metadata {
    idEntityMetadata?: number;
    idEntity?: number;
    entity?: Entity;
    entityMetadataOptions?: EntityMetadataOption[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idEntityMetadata = _data["idEntityMetadata"];
            this.idEntity = _data["idEntity"];
            this.entity = _data["entity"] ? Entity.fromJS(_data["entity"]) : <any>undefined;
            if (Array.isArray(_data["entityMetadataOptions"])) {
                this.entityMetadataOptions = [] as any;
                for (let item of _data["entityMetadataOptions"])
                    this.entityMetadataOptions!.push(EntityMetadataOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityMetadata"] = this.idEntityMetadata;
        data["idEntity"] = this.idEntity;
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        if (Array.isArray(this.entityMetadataOptions)) {
            data["entityMetadataOptions"] = [];
            for (let item of this.entityMetadataOptions)
                data["entityMetadataOptions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): EntityMetadata {
        const json = this.toJSON();
        let result = new EntityMetadata();
        result.init(json);
        return result;
    }
}

export class EntityMetadataOption {
    idEntityMetadata?: number;
    entityMetadata?: EntityMetadata;
    idMetadataFieldOption?: number;
    metadataFieldOption?: MetadataFieldOption;

    init(_data?: any) {
        if (_data) {
            this.idEntityMetadata = _data["idEntityMetadata"];
            this.entityMetadata = _data["entityMetadata"] ? EntityMetadata.fromJS(_data["entityMetadata"]) : <any>undefined;
            this.idMetadataFieldOption = _data["idMetadataFieldOption"];
            this.metadataFieldOption = _data["metadataFieldOption"] ? MetadataFieldOption.fromJS(_data["metadataFieldOption"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityMetadataOption {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMetadataOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityMetadata"] = this.idEntityMetadata;
        data["entityMetadata"] = this.entityMetadata ? this.entityMetadata.toJSON() : <any>undefined;
        data["idMetadataFieldOption"] = this.idMetadataFieldOption;
        data["metadataFieldOption"] = this.metadataFieldOption ? this.metadataFieldOption.toJSON() : <any>undefined;
        return data; 
    }

    clone(): EntityMetadataOption {
        const json = this.toJSON();
        let result = new EntityMetadataOption();
        result.init(json);
        return result;
    }
}

export class UserVsAppGroup extends AuditableEntity {
    idUser?: number;
    user?: User;
    idAppGroup?: number;
    appGroup?: AppGroup;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.idAppGroup = _data["idAppGroup"];
            this.appGroup = _data["appGroup"] ? AppGroup.fromJS(_data["appGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserVsAppGroup {
        data = typeof data === 'object' ? data : {};
        let result = new UserVsAppGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["idAppGroup"] = this.idAppGroup;
        data["appGroup"] = this.appGroup ? this.appGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): UserVsAppGroup {
        const json = this.toJSON();
        let result = new UserVsAppGroup();
        result.init(json);
        return result;
    }
}

export class AppGroup extends AuditableEntity {
    idAppGroup?: number;
    name?: string;
    orderId?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idAppGroup = _data["idAppGroup"];
            this.name = _data["name"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): AppGroup {
        data = typeof data === 'object' ? data : {};
        let result = new AppGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppGroup"] = this.idAppGroup;
        data["name"] = this.name;
        data["orderId"] = this.orderId;
        super.toJSON(data);
        return data; 
    }

    clone(): AppGroup {
        const json = this.toJSON();
        let result = new AppGroup();
        result.init(json);
        return result;
    }
}

export class UserLogin extends AuditableEntity {
    idUserLogin?: number;
    username?: string;
    password?: string;
    passwordSalt?: string;
    passwordRecoverToken?: string | undefined;
    passwordRecoverDate?: string | undefined;
    userLoginVsAppGroups?: UserLoginVsAppGroup[];
    userLoginAccesses?: UserLoginAccess[];
    idUser?: number;
    user?: User;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserLogin = _data["idUserLogin"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.passwordSalt = _data["passwordSalt"];
            this.passwordRecoverToken = _data["passwordRecoverToken"];
            this.passwordRecoverDate = _data["passwordRecoverDate"];
            if (Array.isArray(_data["userLoginVsAppGroups"])) {
                this.userLoginVsAppGroups = [] as any;
                for (let item of _data["userLoginVsAppGroups"])
                    this.userLoginVsAppGroups!.push(UserLoginVsAppGroup.fromJS(item));
            }
            if (Array.isArray(_data["userLoginAccesses"])) {
                this.userLoginAccesses = [] as any;
                for (let item of _data["userLoginAccesses"])
                    this.userLoginAccesses!.push(UserLoginAccess.fromJS(item));
            }
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserLogin"] = this.idUserLogin;
        data["username"] = this.username;
        data["password"] = this.password;
        data["passwordSalt"] = this.passwordSalt;
        data["passwordRecoverToken"] = this.passwordRecoverToken;
        data["passwordRecoverDate"] = this.passwordRecoverDate;
        if (Array.isArray(this.userLoginVsAppGroups)) {
            data["userLoginVsAppGroups"] = [];
            for (let item of this.userLoginVsAppGroups)
                data["userLoginVsAppGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.userLoginAccesses)) {
            data["userLoginAccesses"] = [];
            for (let item of this.userLoginAccesses)
                data["userLoginAccesses"].push(item.toJSON());
        }
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export class UserLoginVsAppGroup extends AuditableEntity {
    idUserLogin?: number;
    userLogin?: UserLogin;
    idAppGroup?: number;
    appGroup?: AppGroup;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserLogin = _data["idUserLogin"];
            this.userLogin = _data["userLogin"] ? UserLogin.fromJS(_data["userLogin"]) : <any>undefined;
            this.idAppGroup = _data["idAppGroup"];
            this.appGroup = _data["appGroup"] ? AppGroup.fromJS(_data["appGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginVsAppGroup {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginVsAppGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserLogin"] = this.idUserLogin;
        data["userLogin"] = this.userLogin ? this.userLogin.toJSON() : <any>undefined;
        data["idAppGroup"] = this.idAppGroup;
        data["appGroup"] = this.appGroup ? this.appGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): UserLoginVsAppGroup {
        const json = this.toJSON();
        let result = new UserLoginVsAppGroup();
        result.init(json);
        return result;
    }
}

export class UserLoginAccess extends AuditableEntity {
    idUserLogin?: number;
    userLogin?: UserLogin;
    idAppInterfaceRole?: number;
    appInterfaceRole?: AppInterfaceRole;
    isActive?: boolean;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserLogin = _data["idUserLogin"];
            this.userLogin = _data["userLogin"] ? UserLogin.fromJS(_data["userLogin"]) : <any>undefined;
            this.idAppInterfaceRole = _data["idAppInterfaceRole"];
            this.appInterfaceRole = _data["appInterfaceRole"] ? AppInterfaceRole.fromJS(_data["appInterfaceRole"]) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UserLoginAccess {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAccess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserLogin"] = this.idUserLogin;
        data["userLogin"] = this.userLogin ? this.userLogin.toJSON() : <any>undefined;
        data["idAppInterfaceRole"] = this.idAppInterfaceRole;
        data["appInterfaceRole"] = this.appInterfaceRole ? this.appInterfaceRole.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data; 
    }

    clone(): UserLoginAccess {
        const json = this.toJSON();
        let result = new UserLoginAccess();
        result.init(json);
        return result;
    }
}

export class AppInterfaceRole extends AuditableEntity {
    idAppInterfaceRole?: number;
    idAppInterface?: number;
    appInterface?: AppInterface;
    canImportOrExport?: boolean;
    appInterfaceRoleAttrs?: AppInterfaceRoleAttr[];
    permissions?: AppInterfaceRoleVsAppInterfaceModule[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idAppInterfaceRole = _data["idAppInterfaceRole"];
            this.idAppInterface = _data["idAppInterface"];
            this.appInterface = _data["appInterface"] ? AppInterface.fromJS(_data["appInterface"]) : <any>undefined;
            this.canImportOrExport = _data["canImportOrExport"];
            if (Array.isArray(_data["appInterfaceRoleAttrs"])) {
                this.appInterfaceRoleAttrs = [] as any;
                for (let item of _data["appInterfaceRoleAttrs"])
                    this.appInterfaceRoleAttrs!.push(AppInterfaceRoleAttr.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(AppInterfaceRoleVsAppInterfaceModule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppInterfaceRole {
        data = typeof data === 'object' ? data : {};
        let result = new AppInterfaceRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppInterfaceRole"] = this.idAppInterfaceRole;
        data["idAppInterface"] = this.idAppInterface;
        data["appInterface"] = this.appInterface ? this.appInterface.toJSON() : <any>undefined;
        data["canImportOrExport"] = this.canImportOrExport;
        if (Array.isArray(this.appInterfaceRoleAttrs)) {
            data["appInterfaceRoleAttrs"] = [];
            for (let item of this.appInterfaceRoleAttrs)
                data["appInterfaceRoleAttrs"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): AppInterfaceRole {
        const json = this.toJSON();
        let result = new AppInterfaceRole();
        result.init(json);
        return result;
    }
}

export class AppInterface extends AuditableEntity {
    idAppInterface?: number;
    name?: string;
    website?: string;
    isActive?: boolean;
    appInterfaceRoles?: AppInterfaceRole[];
    appInterfaceModules?: AppInterfaceModule[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idAppInterface = _data["idAppInterface"];
            this.name = _data["name"];
            this.website = _data["website"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["appInterfaceRoles"])) {
                this.appInterfaceRoles = [] as any;
                for (let item of _data["appInterfaceRoles"])
                    this.appInterfaceRoles!.push(AppInterfaceRole.fromJS(item));
            }
            if (Array.isArray(_data["appInterfaceModules"])) {
                this.appInterfaceModules = [] as any;
                for (let item of _data["appInterfaceModules"])
                    this.appInterfaceModules!.push(AppInterfaceModule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppInterface {
        data = typeof data === 'object' ? data : {};
        let result = new AppInterface();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppInterface"] = this.idAppInterface;
        data["name"] = this.name;
        data["website"] = this.website;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.appInterfaceRoles)) {
            data["appInterfaceRoles"] = [];
            for (let item of this.appInterfaceRoles)
                data["appInterfaceRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.appInterfaceModules)) {
            data["appInterfaceModules"] = [];
            for (let item of this.appInterfaceModules)
                data["appInterfaceModules"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): AppInterface {
        const json = this.toJSON();
        let result = new AppInterface();
        result.init(json);
        return result;
    }
}

export class AppInterfaceModule extends AuditableEntity {
    idAppInterfaceModule?: number;
    idAppInterface?: number;
    orderId?: number;
    title?: string;
    appInterface?: AppInterface;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idAppInterfaceModule = _data["idAppInterfaceModule"];
            this.idAppInterface = _data["idAppInterface"];
            this.orderId = _data["orderId"];
            this.title = _data["title"];
            this.appInterface = _data["appInterface"] ? AppInterface.fromJS(_data["appInterface"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppInterfaceModule {
        data = typeof data === 'object' ? data : {};
        let result = new AppInterfaceModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppInterfaceModule"] = this.idAppInterfaceModule;
        data["idAppInterface"] = this.idAppInterface;
        data["orderId"] = this.orderId;
        data["title"] = this.title;
        data["appInterface"] = this.appInterface ? this.appInterface.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): AppInterfaceModule {
        const json = this.toJSON();
        let result = new AppInterfaceModule();
        result.init(json);
        return result;
    }
}

export class AppInterfaceRoleAttr {
    idAppInterfaceRole?: number;
    appInterfaceRole?: AppInterfaceRole;
    idLanguage?: number;
    language?: Language;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idAppInterfaceRole = _data["idAppInterfaceRole"];
            this.appInterfaceRole = _data["appInterfaceRole"] ? AppInterfaceRole.fromJS(_data["appInterfaceRole"]) : <any>undefined;
            this.idLanguage = _data["idLanguage"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): AppInterfaceRoleAttr {
        data = typeof data === 'object' ? data : {};
        let result = new AppInterfaceRoleAttr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppInterfaceRole"] = this.idAppInterfaceRole;
        data["appInterfaceRole"] = this.appInterfaceRole ? this.appInterfaceRole.toJSON() : <any>undefined;
        data["idLanguage"] = this.idLanguage;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["title"] = this.title;
        return data; 
    }

    clone(): AppInterfaceRoleAttr {
        const json = this.toJSON();
        let result = new AppInterfaceRoleAttr();
        result.init(json);
        return result;
    }
}

export class AppInterfaceRoleVsAppInterfaceModule extends AuditableEntity {
    idAppInterfaceRole?: number;
    appInterfaceRole?: AppInterfaceRole;
    idAppInterfaceModule?: number;
    appInterfaceModule?: AppInterfaceModule;
    canManageConfigurations?: boolean;
    viewMode?: PermissionTypes;
    editMode?: PermissionTypes;
    deleteMode?: PermissionTypes;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idAppInterfaceRole = _data["idAppInterfaceRole"];
            this.appInterfaceRole = _data["appInterfaceRole"] ? AppInterfaceRole.fromJS(_data["appInterfaceRole"]) : <any>undefined;
            this.idAppInterfaceModule = _data["idAppInterfaceModule"];
            this.appInterfaceModule = _data["appInterfaceModule"] ? AppInterfaceModule.fromJS(_data["appInterfaceModule"]) : <any>undefined;
            this.canManageConfigurations = _data["canManageConfigurations"];
            this.viewMode = _data["viewMode"];
            this.editMode = _data["editMode"];
            this.deleteMode = _data["deleteMode"];
        }
    }

    static fromJS(data: any): AppInterfaceRoleVsAppInterfaceModule {
        data = typeof data === 'object' ? data : {};
        let result = new AppInterfaceRoleVsAppInterfaceModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppInterfaceRole"] = this.idAppInterfaceRole;
        data["appInterfaceRole"] = this.appInterfaceRole ? this.appInterfaceRole.toJSON() : <any>undefined;
        data["idAppInterfaceModule"] = this.idAppInterfaceModule;
        data["appInterfaceModule"] = this.appInterfaceModule ? this.appInterfaceModule.toJSON() : <any>undefined;
        data["canManageConfigurations"] = this.canManageConfigurations;
        data["viewMode"] = this.viewMode;
        data["editMode"] = this.editMode;
        data["deleteMode"] = this.deleteMode;
        super.toJSON(data);
        return data; 
    }

    clone(): AppInterfaceRoleVsAppInterfaceModule {
        const json = this.toJSON();
        let result = new AppInterfaceRoleVsAppInterfaceModule();
        result.init(json);
        return result;
    }
}

export enum PermissionTypes {
    None = 0,
    Mine = 1,
    Descendents = 2,
    All = 3,
}

export class UserMetadata extends Metadata {
    idUserMetadata?: number;
    idUser?: number;
    user?: User;
    userMetadataOptions?: UserMetadataOption[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserMetadata = _data["idUserMetadata"];
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["userMetadataOptions"])) {
                this.userMetadataOptions = [] as any;
                for (let item of _data["userMetadataOptions"])
                    this.userMetadataOptions!.push(UserMetadataOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new UserMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserMetadata"] = this.idUserMetadata;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.userMetadataOptions)) {
            data["userMetadataOptions"] = [];
            for (let item of this.userMetadataOptions)
                data["userMetadataOptions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): UserMetadata {
        const json = this.toJSON();
        let result = new UserMetadata();
        result.init(json);
        return result;
    }
}

export class UserMetadataOption {
    idUserMetadata?: number;
    userMetadata?: UserMetadata;
    idMetadataFieldOption?: number;
    metadataFieldOption?: MetadataFieldOption;

    init(_data?: any) {
        if (_data) {
            this.idUserMetadata = _data["idUserMetadata"];
            this.userMetadata = _data["userMetadata"] ? UserMetadata.fromJS(_data["userMetadata"]) : <any>undefined;
            this.idMetadataFieldOption = _data["idMetadataFieldOption"];
            this.metadataFieldOption = _data["metadataFieldOption"] ? MetadataFieldOption.fromJS(_data["metadataFieldOption"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserMetadataOption {
        data = typeof data === 'object' ? data : {};
        let result = new UserMetadataOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserMetadata"] = this.idUserMetadata;
        data["userMetadata"] = this.userMetadata ? this.userMetadata.toJSON() : <any>undefined;
        data["idMetadataFieldOption"] = this.idMetadataFieldOption;
        data["metadataFieldOption"] = this.metadataFieldOption ? this.metadataFieldOption.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UserMetadataOption {
        const json = this.toJSON();
        let result = new UserMetadataOption();
        result.init(json);
        return result;
    }
}

export class UserComment extends AuditableEntity {
    idUserComment?: number;
    idUser?: number;
    user?: User;
    idUserRelated?: number | undefined;
    userRelated?: User | undefined;
    message?: string;
    isPublic?: boolean;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserComment = _data["idUserComment"];
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.idUserRelated = _data["idUserRelated"];
            this.userRelated = _data["userRelated"] ? User.fromJS(_data["userRelated"]) : <any>undefined;
            this.message = _data["message"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): UserComment {
        data = typeof data === 'object' ? data : {};
        let result = new UserComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserComment"] = this.idUserComment;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["idUserRelated"] = this.idUserRelated;
        data["userRelated"] = this.userRelated ? this.userRelated.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["isPublic"] = this.isPublic;
        super.toJSON(data);
        return data; 
    }

    clone(): UserComment {
        const json = this.toJSON();
        let result = new UserComment();
        result.init(json);
        return result;
    }
}

export class UserLog extends AuditableEntity {
    idUserLog?: number;
    idUser?: number;
    user?: User;
    description?: string | undefined;
    typeId?: UserLogTypes;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserLog = _data["idUserLog"];
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.description = _data["description"];
            this.typeId = _data["typeId"];
        }
    }

    static fromJS(data: any): UserLog {
        data = typeof data === 'object' ? data : {};
        let result = new UserLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserLog"] = this.idUserLog;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["typeId"] = this.typeId;
        super.toJSON(data);
        return data; 
    }

    clone(): UserLog {
        const json = this.toJSON();
        let result = new UserLog();
        result.init(json);
        return result;
    }
}

export enum UserLogTypes {
    Created = 0,
    Edited = 1,
}

export class FeedbackVsUser extends AuditableEntity {
    idFeedbackVsUser?: number;
    idUser?: number;
    user?: User;
    idFeedback?: number;
    feedback?: Feedback;
    dateStart?: string;
    dateEnd?: string;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackVsUser = _data["idFeedbackVsUser"];
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.idFeedback = _data["idFeedback"];
            this.feedback = _data["feedback"] ? Feedback.fromJS(_data["feedback"]) : <any>undefined;
            this.dateStart = _data["dateStart"];
            this.dateEnd = _data["dateEnd"];
        }
    }

    static fromJS(data: any): FeedbackVsUser {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackVsUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackVsUser"] = this.idFeedbackVsUser;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["idFeedback"] = this.idFeedback;
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        data["dateStart"] = this.dateStart;
        data["dateEnd"] = this.dateEnd;
        super.toJSON(data);
        return data; 
    }

    clone(): FeedbackVsUser {
        const json = this.toJSON();
        let result = new FeedbackVsUser();
        result.init(json);
        return result;
    }
}

export class AppGroupVsFeedback extends AuditableEntity {
    idAppGroupVsFeedback?: number;
    idAppGroup?: number;
    appGroup?: AppGroup;
    idFeedback?: number;
    feedback?: Feedback;
    idUser?: number | undefined;
    user?: User | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idAppGroupVsFeedback = _data["idAppGroupVsFeedback"];
            this.idAppGroup = _data["idAppGroup"];
            this.appGroup = _data["appGroup"] ? AppGroup.fromJS(_data["appGroup"]) : <any>undefined;
            this.idFeedback = _data["idFeedback"];
            this.feedback = _data["feedback"] ? Feedback.fromJS(_data["feedback"]) : <any>undefined;
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppGroupVsFeedback {
        data = typeof data === 'object' ? data : {};
        let result = new AppGroupVsFeedback();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idAppGroupVsFeedback"] = this.idAppGroupVsFeedback;
        data["idAppGroup"] = this.idAppGroup;
        data["appGroup"] = this.appGroup ? this.appGroup.toJSON() : <any>undefined;
        data["idFeedback"] = this.idFeedback;
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }

    clone(): AppGroupVsFeedback {
        const json = this.toJSON();
        let result = new AppGroupVsFeedback();
        result.init(json);
        return result;
    }
}

export class FeedbackQuestionType extends AuditableEntity {
    idFeedbackQuestionType?: number;
    feedbackQuestionTypeAttrs?: FeedbackQuestionTypeAttr[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackQuestionType = _data["idFeedbackQuestionType"];
            if (Array.isArray(_data["feedbackQuestionTypeAttrs"])) {
                this.feedbackQuestionTypeAttrs = [] as any;
                for (let item of _data["feedbackQuestionTypeAttrs"])
                    this.feedbackQuestionTypeAttrs!.push(FeedbackQuestionTypeAttr.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeedbackQuestionType {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackQuestionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackQuestionType"] = this.idFeedbackQuestionType;
        if (Array.isArray(this.feedbackQuestionTypeAttrs)) {
            data["feedbackQuestionTypeAttrs"] = [];
            for (let item of this.feedbackQuestionTypeAttrs)
                data["feedbackQuestionTypeAttrs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): FeedbackQuestionType {
        const json = this.toJSON();
        let result = new FeedbackQuestionType();
        result.init(json);
        return result;
    }
}

export class FeedbackQuestionTypeAttr {
    idFeedbackQuestionType?: number;
    feedbackQuestionType?: FeedbackQuestionType;
    idLanguage?: number;
    language?: Language;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idFeedbackQuestionType = _data["idFeedbackQuestionType"];
            this.feedbackQuestionType = _data["feedbackQuestionType"] ? FeedbackQuestionType.fromJS(_data["feedbackQuestionType"]) : <any>undefined;
            this.idLanguage = _data["idLanguage"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): FeedbackQuestionTypeAttr {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackQuestionTypeAttr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackQuestionType"] = this.idFeedbackQuestionType;
        data["feedbackQuestionType"] = this.feedbackQuestionType ? this.feedbackQuestionType.toJSON() : <any>undefined;
        data["idLanguage"] = this.idLanguage;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["title"] = this.title;
        return data; 
    }

    clone(): FeedbackQuestionTypeAttr {
        const json = this.toJSON();
        let result = new FeedbackQuestionTypeAttr();
        result.init(json);
        return result;
    }
}

export class MultipleFeedbackAnswerRequestCommand {
    answers?: FeedbackAnswer[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(FeedbackAnswer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MultipleFeedbackAnswerRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MultipleFeedbackAnswerRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MultipleFeedbackAnswerRequestCommand {
        const json = this.toJSON();
        let result = new MultipleFeedbackAnswerRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateMultipleFeedbackAnswerCommand extends MultipleFeedbackAnswerRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateMultipleFeedbackAnswerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultipleFeedbackAnswerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateMultipleFeedbackAnswerCommand {
        const json = this.toJSON();
        let result = new CreateMultipleFeedbackAnswerCommand();
        result.init(json);
        return result;
    }
}

export class FeedbackAnswer extends AuditableEntity {
    idFeedbackAnswer?: number;
    idFeedbackQuestion?: number;
    feedbackQuestion?: FeedbackQuestion;
    idFeedbackQuestionGroup?: number;
    feedbackQuestionGroup?: FeedbackQuestionGroup;
    idUser?: number;
    user?: User;
    answer?: string;
    idFeedbackType?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackAnswer = _data["idFeedbackAnswer"];
            this.idFeedbackQuestion = _data["idFeedbackQuestion"];
            this.feedbackQuestion = _data["feedbackQuestion"] ? FeedbackQuestion.fromJS(_data["feedbackQuestion"]) : <any>undefined;
            this.idFeedbackQuestionGroup = _data["idFeedbackQuestionGroup"];
            this.feedbackQuestionGroup = _data["feedbackQuestionGroup"] ? FeedbackQuestionGroup.fromJS(_data["feedbackQuestionGroup"]) : <any>undefined;
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.answer = _data["answer"];
            this.idFeedbackType = _data["idFeedbackType"];
        }
    }

    static fromJS(data: any): FeedbackAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackAnswer"] = this.idFeedbackAnswer;
        data["idFeedbackQuestion"] = this.idFeedbackQuestion;
        data["feedbackQuestion"] = this.feedbackQuestion ? this.feedbackQuestion.toJSON() : <any>undefined;
        data["idFeedbackQuestionGroup"] = this.idFeedbackQuestionGroup;
        data["feedbackQuestionGroup"] = this.feedbackQuestionGroup ? this.feedbackQuestionGroup.toJSON() : <any>undefined;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["answer"] = this.answer;
        data["idFeedbackType"] = this.idFeedbackType;
        super.toJSON(data);
        return data; 
    }

    clone(): FeedbackAnswer {
        const json = this.toJSON();
        let result = new FeedbackAnswer();
        result.init(json);
        return result;
    }
}

export class EditFeedbackAnswerCommand extends FeedbackAnswerRequestCommand {
    idFeedbackAnswer?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackAnswer = _data["idFeedbackAnswer"];
        }
    }

    static fromJS(data: any): EditFeedbackAnswerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditFeedbackAnswerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackAnswer"] = this.idFeedbackAnswer;
        super.toJSON(data);
        return data; 
    }

    clone(): EditFeedbackAnswerCommand {
        const json = this.toJSON();
        let result = new EditFeedbackAnswerCommand();
        result.init(json);
        return result;
    }
}

export enum GetFeedbackCommentsDtosOrderOptions {
    TitleAsc = 0,
    TitleDesc = 1,
    DateCreatedAsc = 2,
    DateCreatedDesc = 3,
    DateStartAsc = 4,
    DateStartDesc = 5,
}

export enum GetFeedbackCommentsDtosPeriodOptions {
    All = 0,
    Today = 1,
    Week = 2,
    Month = 3,
}

export enum GetFeedbackCommentsDtosPrivacyOptions {
    Mine = 1,
    All = 2,
}

export class FeedbackCommentRequestCommand {
    idFeedbackComment?: number;
    idFeedback?: number;
    feedback?: Feedback;
    idUser?: number | undefined;
    user?: User | undefined;
    message?: string;
    isPublic?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idFeedbackComment = _data["idFeedbackComment"];
            this.idFeedback = _data["idFeedback"];
            this.feedback = _data["feedback"] ? Feedback.fromJS(_data["feedback"]) : <any>undefined;
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.message = _data["message"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): FeedbackCommentRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackCommentRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackComment"] = this.idFeedbackComment;
        data["idFeedback"] = this.idFeedback;
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): FeedbackCommentRequestCommand {
        const json = this.toJSON();
        let result = new FeedbackCommentRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateFeedbackCommentCommand extends FeedbackCommentRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateFeedbackCommentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFeedbackCommentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateFeedbackCommentCommand {
        const json = this.toJSON();
        let result = new CreateFeedbackCommentCommand();
        result.init(json);
        return result;
    }
}

export class EditFeedbackCommentCommand extends FeedbackCommentRequestCommand {
    idFeedbackComment?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackComment = _data["idFeedbackComment"];
        }
    }

    static fromJS(data: any): EditFeedbackCommentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditFeedbackCommentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackComment"] = this.idFeedbackComment;
        super.toJSON(data);
        return data; 
    }

    clone(): EditFeedbackCommentCommand {
        const json = this.toJSON();
        let result = new EditFeedbackCommentCommand();
        result.init(json);
        return result;
    }
}

export enum GetFeedbackQuestionGroupsDtosOrderOptions {
    TitleAsc = 0,
    TitleDesc = 1,
    Reflection = 2,
    OrderId = 3,
    OrderIdDesc = 4,
    TypeId = 5,
    TypeIdDesc = 6,
}

export class FeedbackQuestionGroupRequestCommand {
    idFeedbackQuestionGroup?: number;
    idFeedback?: number;
    title?: string;
    sendToStatistics?: boolean;
    reflection?: number;
    orderId?: number;

    init(_data?: any) {
        if (_data) {
            this.idFeedbackQuestionGroup = _data["idFeedbackQuestionGroup"];
            this.idFeedback = _data["idFeedback"];
            this.title = _data["title"];
            this.sendToStatistics = _data["sendToStatistics"];
            this.reflection = _data["reflection"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): FeedbackQuestionGroupRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackQuestionGroupRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackQuestionGroup"] = this.idFeedbackQuestionGroup;
        data["idFeedback"] = this.idFeedback;
        data["title"] = this.title;
        data["sendToStatistics"] = this.sendToStatistics;
        data["reflection"] = this.reflection;
        data["orderId"] = this.orderId;
        return data; 
    }

    clone(): FeedbackQuestionGroupRequestCommand {
        const json = this.toJSON();
        let result = new FeedbackQuestionGroupRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateFeedbackQuestionGroupCommand extends FeedbackQuestionGroupRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateFeedbackQuestionGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFeedbackQuestionGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateFeedbackQuestionGroupCommand {
        const json = this.toJSON();
        let result = new CreateFeedbackQuestionGroupCommand();
        result.init(json);
        return result;
    }
}

export class EditFeedbackQuestionGroupCommand extends FeedbackQuestionGroupRequestCommand {
    idFeedbackQuestionGroup?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackQuestionGroup = _data["idFeedbackQuestionGroup"];
        }
    }

    static fromJS(data: any): EditFeedbackQuestionGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditFeedbackQuestionGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackQuestionGroup"] = this.idFeedbackQuestionGroup;
        super.toJSON(data);
        return data; 
    }

    clone(): EditFeedbackQuestionGroupCommand {
        const json = this.toJSON();
        let result = new EditFeedbackQuestionGroupCommand();
        result.init(json);
        return result;
    }
}

export class ReorderFeedbackQuestionGroupsCommand {
    ids?: number[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderFeedbackQuestionGroupsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderFeedbackQuestionGroupsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }

    clone(): ReorderFeedbackQuestionGroupsCommand {
        const json = this.toJSON();
        let result = new ReorderFeedbackQuestionGroupsCommand();
        result.init(json);
        return result;
    }
}

export enum GetFeedbackQuestionsDtosOrderOptions {
    TitleAsc = 0,
    TitleDesc = 1,
    Reflection = 2,
    OrderId = 3,
    OrderIdDesc = 4,
    TypeId = 5,
    TypeIdDesc = 6,
}

export class FeedbackQuestionRequestCommand {
    idFeedbackQuestion?: number;
    idFeedbackQuestionGroup?: number;
    orderId?: number;
    idFeedbackQuestionType?: number;
    reflection?: number;
    title?: string;
    description?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.idFeedbackQuestion = _data["idFeedbackQuestion"];
            this.idFeedbackQuestionGroup = _data["idFeedbackQuestionGroup"];
            this.orderId = _data["orderId"];
            this.idFeedbackQuestionType = _data["idFeedbackQuestionType"];
            this.reflection = _data["reflection"];
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FeedbackQuestionRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackQuestionRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackQuestion"] = this.idFeedbackQuestion;
        data["idFeedbackQuestionGroup"] = this.idFeedbackQuestionGroup;
        data["orderId"] = this.orderId;
        data["idFeedbackQuestionType"] = this.idFeedbackQuestionType;
        data["reflection"] = this.reflection;
        data["title"] = this.title;
        data["description"] = this.description;
        return data; 
    }

    clone(): FeedbackQuestionRequestCommand {
        const json = this.toJSON();
        let result = new FeedbackQuestionRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateFeedbackQuestionCommand extends FeedbackQuestionRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateFeedbackQuestionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFeedbackQuestionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateFeedbackQuestionCommand {
        const json = this.toJSON();
        let result = new CreateFeedbackQuestionCommand();
        result.init(json);
        return result;
    }
}

export class EditFeedbackQuestionCommand extends FeedbackQuestionRequestCommand {
    idFeedbackQuestion?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackQuestion = _data["idFeedbackQuestion"];
        }
    }

    static fromJS(data: any): EditFeedbackQuestionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditFeedbackQuestionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackQuestion"] = this.idFeedbackQuestion;
        super.toJSON(data);
        return data; 
    }

    clone(): EditFeedbackQuestionCommand {
        const json = this.toJSON();
        let result = new EditFeedbackQuestionCommand();
        result.init(json);
        return result;
    }
}

export class ReorderFeedbackQuestionsCommand {
    ids?: number[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderFeedbackQuestionsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderFeedbackQuestionsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }

    clone(): ReorderFeedbackQuestionsCommand {
        const json = this.toJSON();
        let result = new ReorderFeedbackQuestionsCommand();
        result.init(json);
        return result;
    }
}

export class GetFeedbackQuestionTypesDtosIncludeOptions {

    init(_data?: any) {
    }

    static fromJS(data: any): GetFeedbackQuestionTypesDtosIncludeOptions {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedbackQuestionTypesDtosIncludeOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): GetFeedbackQuestionTypesDtosIncludeOptions {
        const json = this.toJSON();
        let result = new GetFeedbackQuestionTypesDtosIncludeOptions();
        result.init(json);
        return result;
    }
}

export enum GetFeedbacksDtosOrderOptions {
    TitleAsc = 0,
    TitleDesc = 1,
    DateCreatedAsc = 2,
    DateCreatedDesc = 3,
    DateStartAsc = 4,
    DateStartDesc = 5,
}

export enum GetFeedbacksDtosPeriodOptions {
    All = 0,
    Today = 1,
    Week = 2,
    Month = 3,
}

export enum GetFeedbacksDtosPrivacyOptions {
    Mine = 1,
    All = 2,
}

export class FeedbackRequestCommand {
    idFeedback?: number;
    idFeedbackType?: number | undefined;
    feedbackType?: FeedbackType | undefined;
    idUser?: number | undefined;
    user?: User | undefined;
    title?: string;
    description?: string | undefined;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
    resolved?: boolean;
    icon?: string | undefined;
    feedbackQuestionGroups?: number[] | undefined;
    appGroups?: number[] | undefined;
    evaluation180Weighted?: number;
    evaluatorEvaluationWeighted?: number;
    selfEvaluationWeighted?: number;
    teamEvaluationWeighted?: number;
    selfEvaluationDateEnd?: string | undefined;
    evaluatorEvaluationDateEnd?: string | undefined;
    evaluation180DateEnd?: string | undefined;
    idFeedback180?: number;

    init(_data?: any) {
        if (_data) {
            this.idFeedback = _data["idFeedback"];
            this.idFeedbackType = _data["idFeedbackType"];
            this.feedbackType = _data["feedbackType"] ? FeedbackType.fromJS(_data["feedbackType"]) : <any>undefined;
            this.idUser = _data["idUser"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.dateStart = _data["dateStart"];
            this.dateEnd = _data["dateEnd"];
            this.resolved = _data["resolved"];
            this.icon = _data["icon"];
            this.evaluation180Weighted = _data["evaluation180Weighted"];
            this.evaluatorEvaluationWeighted = _data["evaluatorEvaluationWeighted"];
            this.selfEvaluationWeighted = _data["selfEvaluationWeighted"];
            this.teamEvaluationWeighted = _data["teamEvaluationWeighted"];
            this.selfEvaluationDateEnd = _data["selfEvaluationDateEnd"];
            this.evaluatorEvaluationDateEnd = _data["evaluatorEvaluationDateEnd"];
            this.evaluation180DateEnd = _data["evaluation180DateEnd"];
            this.idFeedback180 = _data["idFeedback180"];
            if (Array.isArray(_data["feedbackQuestionGroups"])) {
                this.feedbackQuestionGroups = [] as any;
                for (let item of _data["feedbackQuestionGroups"])
                    this.feedbackQuestionGroups!.push(item);
            }
            if (Array.isArray(_data["appGroups"])) {
                this.appGroups = [] as any;
                for (let item of _data["appGroups"])
                    this.appGroups!.push(item);
            }
        }
    }

    static fromJS(data: any): FeedbackRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedback"] = this.idFeedback;
        data["idFeedbackType"] = this.idFeedbackType;
        data["feedbackType"] = this.feedbackType ? this.feedbackType.toJSON() : <any>undefined;
        data["idUser"] = this.idUser;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["dateStart"] = this.dateStart;
        data["dateEnd"] = this.dateEnd;
        data["resolved"] = this.resolved;
        data["icon"] = this.icon;
        data["evaluation180Weighted"] = this.evaluation180Weighted;
        data["evaluatorEvaluationWeighted"] = this.evaluatorEvaluationWeighted;
        data["selfEvaluationWeighted"] = this.selfEvaluationWeighted;
        data["teamEvaluationWeighted"] = this.teamEvaluationWeighted;
        data["selfEvaluationDateEnd"] = this.selfEvaluationDateEnd;
        data["evaluatorEvaluationDateEnd"] = this.evaluatorEvaluationDateEnd;
        data["evaluation180DateEnd"] = this.evaluation180DateEnd;
        data["idFeedback180"] = this.idFeedback180;
        if (Array.isArray(this.feedbackQuestionGroups)) {
            data["feedbackQuestionGroups"] = [];
            for (let item of this.feedbackQuestionGroups)
                data["feedbackQuestionGroups"].push(item);
        }
        if (Array.isArray(this.appGroups)) {
            data["appGroups"] = [];
            for (let item of this.appGroups)
                data["appGroups"].push(item);
        }
        return data; 
    }

    clone(): FeedbackRequestCommand {
        const json = this.toJSON();
        let result = new FeedbackRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateFeedbackCommand extends FeedbackRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateFeedbackCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFeedbackCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateFeedbackCommand {
        const json = this.toJSON();
        let result = new CreateFeedbackCommand();
        result.init(json);
        return result;
    }
}

export class EditFeedbackCommand extends FeedbackRequestCommand {
    idFeedback?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedback = _data["idFeedback"];
        }
    }

    static fromJS(data: any): EditFeedbackCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditFeedbackCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedback"] = this.idFeedback;
        super.toJSON(data);
        return data; 
    }

    clone(): EditFeedbackCommand {
        const json = this.toJSON();
        let result = new EditFeedbackCommand();
        result.init(json);
        return result;
    }
}

export class FeedbackTypeRequestCommand {
    title?: string;
    icon?: string;

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): FeedbackTypeRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackTypeRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["icon"] = this.icon;
        return data; 
    }

    clone(): FeedbackTypeRequestCommand {
        const json = this.toJSON();
        let result = new FeedbackTypeRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateFeedbackTypeCommand extends FeedbackTypeRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateFeedbackTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFeedbackTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateFeedbackTypeCommand {
        const json = this.toJSON();
        let result = new CreateFeedbackTypeCommand();
        result.init(json);
        return result;
    }
}

export class EditFeedbackTypeCommand extends FeedbackTypeRequestCommand {
    idFeedbackType?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackType = _data["idFeedbackType"];
        }
    }

    static fromJS(data: any): EditFeedbackTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditFeedbackTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackType"] = this.idFeedbackType;
        super.toJSON(data);
        return data; 
    }

    clone(): EditFeedbackTypeCommand {
        const json = this.toJSON();
        let result = new EditFeedbackTypeCommand();
        result.init(json);
        return result;
    }
}

export class CreateFeedbackVsUser180Command extends FeedbackRequestCommand {
    idUserRequest?: number;
    idUserResponse?: number;
    feedbackAnswer?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserRequest = _data["idUserRequest"];
            this.idUserResponse = _data["idUserResponse"];
            this.feedbackAnswer = _data["feedbackAnswer"];
        }
    }

    static fromJS(data: any): CreateFeedbackVsUser180Command {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFeedbackVsUser180Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserRequest"] = this.idUserRequest;
        data["idUserResponse"] = this.idUserResponse;
        data["feedbackAnswer"] = this.feedbackAnswer;
        super.toJSON(data);
        return data; 
    }

    clone(): CreateFeedbackVsUser180Command {
        const json = this.toJSON();
        let result = new CreateFeedbackVsUser180Command();
        result.init(json);
        return result;
    }
}

export class FeedbackVsUser180 extends AuditableEntity {
    idFeedbackVsUser180?: number;
    idFeedback?: number;
    idUserRequest?: number;
    idUserResponse?: number;
    feedbackAnswer?: string;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idFeedbackVsUser180 = _data["idFeedbackVsUser180"];
            this.idFeedback = _data["idFeedback"];
            this.idUserRequest = _data["idUserRequest"];
            this.idUserResponse = _data["idUserResponse"];
            this.feedbackAnswer = _data["feedbackAnswer"];
        }
    }

    static fromJS(data: any): FeedbackVsUser180 {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackVsUser180();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idFeedbackVsUser180"] = this.idFeedbackVsUser180;
        data["idFeedback"] = this.idFeedback;
        data["idUserRequest"] = this.idUserRequest;
        data["idUserResponse"] = this.idUserResponse;
        data["feedbackAnswer"] = this.feedbackAnswer;
        super.toJSON(data);
        return data; 
    }

    clone(): FeedbackVsUser180 {
        const json = this.toJSON();
        let result = new FeedbackVsUser180();
        result.init(json);
        return result;
    }
}

export class MultipleFeedbackVsUser180RequestCommand {
    feedbacksVsUser180?: FeedbackVsUser180[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["feedbacksVsUser180"])) {
                this.feedbacksVsUser180 = [] as any;
                for (let item of _data["feedbacksVsUser180"])
                    this.feedbacksVsUser180!.push(FeedbackVsUser180.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MultipleFeedbackVsUser180RequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MultipleFeedbackVsUser180RequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.feedbacksVsUser180)) {
            data["feedbacksVsUser180"] = [];
            for (let item of this.feedbacksVsUser180)
                data["feedbacksVsUser180"].push(item.toJSON());
        }
        return data; 
    }

    clone(): MultipleFeedbackVsUser180RequestCommand {
        const json = this.toJSON();
        let result = new MultipleFeedbackVsUser180RequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateMultipleFeedbackVsUser180Command extends MultipleFeedbackVsUser180RequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateMultipleFeedbackVsUser180Command {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultipleFeedbackVsUser180Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateMultipleFeedbackVsUser180Command {
        const json = this.toJSON();
        let result = new CreateMultipleFeedbackVsUser180Command();
        result.init(json);
        return result;
    }
}

export class CreateMetadataFieldCommand {
    idMetadataGroup?: number;
    title?: string;
    reference?: string;
    orderId?: number;
    idLanguage?: number;
    default?: string;
    photo?: string;
    validation?: string;
    description?: string;
    typeId?: number;
    isRequired?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idMetadataGroup = _data["idMetadataGroup"];
            this.title = _data["title"];
            this.reference = _data["reference"];
            this.orderId = _data["orderId"];
            this.idLanguage = _data["idLanguage"];
            this.default = _data["default"];
            this.photo = _data["photo"];
            this.validation = _data["validation"];
            this.description = _data["description"];
            this.typeId = _data["typeId"];
            this.isRequired = _data["isRequired"];
        }
    }

    static fromJS(data: any): CreateMetadataFieldCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMetadataFieldCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataGroup"] = this.idMetadataGroup;
        data["title"] = this.title;
        data["reference"] = this.reference;
        data["orderId"] = this.orderId;
        data["idLanguage"] = this.idLanguage;
        data["default"] = this.default;
        data["photo"] = this.photo;
        data["validation"] = this.validation;
        data["description"] = this.description;
        data["typeId"] = this.typeId;
        data["isRequired"] = this.isRequired;
        return data; 
    }

    clone(): CreateMetadataFieldCommand {
        const json = this.toJSON();
        let result = new CreateMetadataFieldCommand();
        result.init(json);
        return result;
    }
}

export class EditMetadataFieldCommand {
    idMetadataField?: number;
    idMetadataGroup?: number;
    title?: string;
    reference?: string;
    orderId?: number;
    idLanguage?: number;
    default?: string;
    photo?: string;
    typeId?: number;
    validation?: string;
    description?: string;
    isRequired?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idMetadataField = _data["idMetadataField"];
            this.idMetadataGroup = _data["idMetadataGroup"];
            this.title = _data["title"];
            this.reference = _data["reference"];
            this.orderId = _data["orderId"];
            this.idLanguage = _data["idLanguage"];
            this.default = _data["default"];
            this.photo = _data["photo"];
            this.typeId = _data["typeId"];
            this.validation = _data["validation"];
            this.description = _data["description"];
            this.isRequired = _data["isRequired"];
        }
    }

    static fromJS(data: any): EditMetadataFieldCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditMetadataFieldCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataField"] = this.idMetadataField;
        data["idMetadataGroup"] = this.idMetadataGroup;
        data["title"] = this.title;
        data["reference"] = this.reference;
        data["orderId"] = this.orderId;
        data["idLanguage"] = this.idLanguage;
        data["default"] = this.default;
        data["photo"] = this.photo;
        data["typeId"] = this.typeId;
        data["validation"] = this.validation;
        data["description"] = this.description;
        data["isRequired"] = this.isRequired;
        return data; 
    }

    clone(): EditMetadataFieldCommand {
        const json = this.toJSON();
        let result = new EditMetadataFieldCommand();
        result.init(json);
        return result;
    }
}

export class ReorderMetadataFieldCommand {
    ids?: number[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderMetadataFieldCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderMetadataFieldCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }

    clone(): ReorderMetadataFieldCommand {
        const json = this.toJSON();
        let result = new ReorderMetadataFieldCommand();
        result.init(json);
        return result;
    }
}

export class CreateMetadataFieldOptionCommand {
    title?: string;
    photo?: string;
    orderId?: number;
    idLanguage?: number;
    idMetadataField?: number;

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.photo = _data["photo"];
            this.orderId = _data["orderId"];
            this.idLanguage = _data["idLanguage"];
            this.idMetadataField = _data["idMetadataField"];
        }
    }

    static fromJS(data: any): CreateMetadataFieldOptionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMetadataFieldOptionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["photo"] = this.photo;
        data["orderId"] = this.orderId;
        data["idLanguage"] = this.idLanguage;
        data["idMetadataField"] = this.idMetadataField;
        return data; 
    }

    clone(): CreateMetadataFieldOptionCommand {
        const json = this.toJSON();
        let result = new CreateMetadataFieldOptionCommand();
        result.init(json);
        return result;
    }
}

export class EditMetadataFieldOptionCommand {
    idMetadataFieldOption?: number;
    idMetadataField?: number;
    title?: string;
    photo?: string;
    orderId?: number;
    idLanguage?: number;

    init(_data?: any) {
        if (_data) {
            this.idMetadataFieldOption = _data["idMetadataFieldOption"];
            this.idMetadataField = _data["idMetadataField"];
            this.title = _data["title"];
            this.photo = _data["photo"];
            this.orderId = _data["orderId"];
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): EditMetadataFieldOptionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditMetadataFieldOptionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataFieldOption"] = this.idMetadataFieldOption;
        data["idMetadataField"] = this.idMetadataField;
        data["title"] = this.title;
        data["photo"] = this.photo;
        data["orderId"] = this.orderId;
        data["idLanguage"] = this.idLanguage;
        return data; 
    }

    clone(): EditMetadataFieldOptionCommand {
        const json = this.toJSON();
        let result = new EditMetadataFieldOptionCommand();
        result.init(json);
        return result;
    }
}

export class ReorderMetadataFieldOptionsCommand {
    ids?: number[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderMetadataFieldOptionsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderMetadataFieldOptionsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }

    clone(): ReorderMetadataFieldOptionsCommand {
        const json = this.toJSON();
        let result = new ReorderMetadataFieldOptionsCommand();
        result.init(json);
        return result;
    }
}

export class CreateMetadataGroupCommand {
    title?: string;
    orderId?: number;
    idLanguage?: number;
    visibleOnCreate?: boolean;

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.orderId = _data["orderId"];
            this.idLanguage = _data["idLanguage"];
            this.visibleOnCreate = _data["visibleOnCreate"];
        }
    }

    static fromJS(data: any): CreateMetadataGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMetadataGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["orderId"] = this.orderId;
        data["idLanguage"] = this.idLanguage;
        data["visibleOnCreate"] = this.visibleOnCreate;
        return data; 
    }

    clone(): CreateMetadataGroupCommand {
        const json = this.toJSON();
        let result = new CreateMetadataGroupCommand();
        result.init(json);
        return result;
    }
}

export class EditMetadataGroupCommand {
    idMetadataGroup?: number;
    title?: string;
    orderId?: number;
    visibleOnCreate?: boolean;
    idLanguage?: number;

    init(_data?: any) {
        if (_data) {
            this.idMetadataGroup = _data["idMetadataGroup"];
            this.title = _data["title"];
            this.orderId = _data["orderId"];
            this.visibleOnCreate = _data["visibleOnCreate"];
            this.idLanguage = _data["idLanguage"];
        }
    }

    static fromJS(data: any): EditMetadataGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditMetadataGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMetadataGroup"] = this.idMetadataGroup;
        data["title"] = this.title;
        data["orderId"] = this.orderId;
        data["visibleOnCreate"] = this.visibleOnCreate;
        data["idLanguage"] = this.idLanguage;
        return data; 
    }

    clone(): EditMetadataGroupCommand {
        const json = this.toJSON();
        let result = new EditMetadataGroupCommand();
        result.init(json);
        return result;
    }
}

export class ReorderMetadataGroupsCommand {
    ids?: number[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderMetadataGroupsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderMetadataGroupsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }

    clone(): ReorderMetadataGroupsCommand {
        const json = this.toJSON();
        let result = new ReorderMetadataGroupsCommand();
        result.init(json);
        return result;
    }
}

export enum GetUsersDtosOrderOptions {
    NameAsc = 0,
    NameDesc = 1,
    EmailAsc = 2,
    EmailDesc = 3,
    ContactDefaultAsc = 4,
    ContactDefaultDesc = 5,
    DateCreatedAsc = 6,
    DateCreatedDesc = 7,
}

export class CreateUserCommand extends UserRequestCommand {
    metadata?: MetadataConfigurationFieldSimple[];

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(MetadataConfigurationFieldSimple.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): CreateUserCommand {
        const json = this.toJSON();
        let result = new CreateUserCommand();
        result.init(json);
        return result;
    }
}

export class EditUserMetadataCommand {
    idUser?: number;
    metadata?: MetadataConfigurationFieldSimple[];

    init(_data?: any) {
        if (_data) {
            this.idUser = _data["idUser"];
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(MetadataConfigurationFieldSimple.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditUserMetadataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserMetadataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item.toJSON());
        }
        return data; 
    }

    clone(): EditUserMetadataCommand {
        const json = this.toJSON();
        let result = new EditUserMetadataCommand();
        result.init(json);
        return result;
    }
}

export class CreateUserLoginCommand {
    idUser?: number;
    username?: string;
    password?: string;

    init(_data?: any) {
        if (_data) {
            this.idUser = _data["idUser"];
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateUserLoginCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserLoginCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        data["username"] = this.username;
        data["password"] = this.password;
        return data; 
    }

    clone(): CreateUserLoginCommand {
        const json = this.toJSON();
        let result = new CreateUserLoginCommand();
        result.init(json);
        return result;
    }
}

export class UserLoginRequestCommand {
    username?: string;
    password?: string;

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UserLoginRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data; 
    }

    clone(): UserLoginRequestCommand {
        const json = this.toJSON();
        let result = new UserLoginRequestCommand();
        result.init(json);
        return result;
    }
}

export class EditUserLoginCommand extends UserLoginRequestCommand {
    idUserLogin?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserLogin = _data["idUserLogin"];
        }
    }

    static fromJS(data: any): EditUserLoginCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserLoginCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserLogin"] = this.idUserLogin;
        super.toJSON(data);
        return data; 
    }

    clone(): EditUserLoginCommand {
        const json = this.toJSON();
        let result = new EditUserLoginCommand();
        result.init(json);
        return result;
    }
}

export class CreateUserFileCommand {
    idUser?: number;
    title?: string;
    filename?: string;
    isPublic?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idUser = _data["idUser"];
            this.title = _data["title"];
            this.filename = _data["filename"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): CreateUserFileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserFileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        data["title"] = this.title;
        data["filename"] = this.filename;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): CreateUserFileCommand {
        const json = this.toJSON();
        let result = new CreateUserFileCommand();
        result.init(json);
        return result;
    }
}

export class EditUserFileCommand {
    idEntityFile?: number;
    title?: string;
    filename?: string;
    isPublic?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idEntityFile = _data["idEntityFile"];
            this.title = _data["title"];
            this.filename = _data["filename"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): EditUserFileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserFileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idEntityFile"] = this.idEntityFile;
        data["title"] = this.title;
        data["filename"] = this.filename;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): EditUserFileCommand {
        const json = this.toJSON();
        let result = new EditUserFileCommand();
        result.init(json);
        return result;
    }
}

export class CreateUserCommentCommand {
    idUser?: number;
    message?: string;
    isPublic?: boolean;

    init(_data?: any) {
        if (_data) {
            this.idUser = _data["idUser"];
            this.message = _data["message"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): CreateUserCommentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUser"] = this.idUser;
        data["message"] = this.message;
        data["isPublic"] = this.isPublic;
        return data; 
    }

    clone(): CreateUserCommentCommand {
        const json = this.toJSON();
        let result = new CreateUserCommentCommand();
        result.init(json);
        return result;
    }
}

export class UserTypeRequestCommand {
    idLanguage?: number;
    orderId?: number;
    title?: string;

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.orderId = _data["orderId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UserTypeRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserTypeRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["orderId"] = this.orderId;
        data["title"] = this.title;
        return data; 
    }

    clone(): UserTypeRequestCommand {
        const json = this.toJSON();
        let result = new UserTypeRequestCommand();
        result.init(json);
        return result;
    }
}

export class CreateUserTypeCommand extends UserTypeRequestCommand {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateUserTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): CreateUserTypeCommand {
        const json = this.toJSON();
        let result = new CreateUserTypeCommand();
        result.init(json);
        return result;
    }
}

export class EditUserTypeCommand extends UserTypeRequestCommand {
    idUserType?: number;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idUserType = _data["idUserType"];
        }
    }

    static fromJS(data: any): EditUserTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idUserType"] = this.idUserType;
        super.toJSON(data);
        return data; 
    }

    clone(): EditUserTypeCommand {
        const json = this.toJSON();
        let result = new EditUserTypeCommand();
        result.init(json);
        return result;
    }
}

export class ReorderUserTypesCommand {
    ids?: number[];

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderUserTypesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderUserTypesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }

    clone(): ReorderUserTypesCommand {
        const json = this.toJSON();
        let result = new ReorderUserTypesCommand();
        result.init(json);
        return result;
    }
}

export class EditUserTypeMetadataGroupsConfigurationCommand {
    idLanguage?: number;
    idUserType?: number;
    metadataGroups?: number[];

    init(_data?: any) {
        if (_data) {
            this.idLanguage = _data["idLanguage"];
            this.idUserType = _data["idUserType"];
            if (Array.isArray(_data["metadataGroups"])) {
                this.metadataGroups = [] as any;
                for (let item of _data["metadataGroups"])
                    this.metadataGroups!.push(item);
            }
        }
    }

    static fromJS(data: any): EditUserTypeMetadataGroupsConfigurationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserTypeMetadataGroupsConfigurationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idLanguage"] = this.idLanguage;
        data["idUserType"] = this.idUserType;
        if (Array.isArray(this.metadataGroups)) {
            data["metadataGroups"] = [];
            for (let item of this.metadataGroups)
                data["metadataGroups"].push(item);
        }
        return data; 
    }

    clone(): EditUserTypeMetadataGroupsConfigurationCommand {
        const json = this.toJSON();
        let result = new EditUserTypeMetadataGroupsConfigurationCommand();
        result.init(json);
        return result;
    }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}